
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langjp,langar, langxby,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  "公告详情":"Detalles del anuncio",
  "未读":"No leído",
  "已读":"Leer",
  "主动取消":"Cancelación activa",
  "申请拒绝":"Rechazo de solicitud",
  "赎回拒绝":"Rechazo de la redención",
  "重新申请":"Aplicar de nuevo",
  "撤回申请":"Retirada de la solicitud",
  "在这里购买有潜力的":"Compra potencial aquí",
    "什么是新币申购？":"¿Qué es la suscripción de nuevas monedas?",
    "投资价值高":"投资价值高",
    "新币价格低，潜在价值高，适合投资":"La nueva moneda tiene un precio bajo y un alto valor potencial, adecuada para la inversión.",
    "无手续费":"Sin cargo por manejo",
    "购买新币不需要任何手续费":"No se requieren tarifas para comprar nuevas monedas",
    "是交易产品中风险最低且收益稳定的一种投资方式":"Es un método de inversión con el menor riesgo y rendimientos estables entre los productos comerciales.",
    "产品":"producto",
    "我的申购订单":"Mi orden de compra",
    "总数量":"Cantidad total",
    "已认购量":"Monto suscrito",
    "剩余数量":"Cantidad restante",
    "锁仓天数":"Días de encierro",
    "浅色模式":"Modo claro",
    "深色模式":"Modo oscuro",
  "修改昵称":"Cambiar apodo",
  "昵称":"Apodo",
  "头像":"Avatar",
  "绑定邮箱":"Vincular correo",
  "绑定手机号":"Vincular teléfono",
  "未绑定":"No vinculado",
  "上传头像":"Subir avatar",
  "修改头像":"Modificar avatar",
  "个人信息":"Información Personal",
  "我们发送了验证码至":"Enviamos el código de verificación a",
  "中":"en",
  "请输入获取到的验证码以激活账户":"Por favor, ingrese el código de verificación para activar su cuenta",
    "请输入昵称":"Por favor, introduzca su apodo",
    "手机号":"Número de teléfono",
    "邮箱号":"Dirección de correo electrónico",
    "请输入邮箱号":"Por favor, introduzca su dirección de correo electrónico",
  "白皮书":"Libro blanco",
  "驾驶证":"Licencia de conducir",
  "居住证":"Tarjeta de residencia",
  "通过时间":"Pasando el tiempo",
  "银行账户":"Cuenta bancaria",
    "请输入银行账户":"Ingrese el número de cuenta bancaria.",
    "银行国际代码":"Código SWIFT",
    "请输入国际代码":"Ingrese el código internacional.",
    "电话号码":"Número de teléfono",
    "请输入电话号码":"Ingrese su número de teléfono",
    "上传房屋证明":"Cargue comprobante de vivienda",
    "上传收入证明":"Cargue comprobante de ingresos",
    "上传银行证明":"Cargue comprobante bancario",
    "上传证件照":"Cargue foto de identificación",
    "提示:您可以通过上传证明来提高信用分":"Sugerencia: puede mejorar su puntaje crediticio cargando comprobantes",
    "谷歌验证码":"Código de Google",
    "修改谷歌验证码":"Modificar código de Google",
    "扫描二维码绑定":"Escanear código QR",
    "输入验证码":"Ingresar código",
    "你知道吗？":"¿Sabías que?",
    "绑定2FA认证,提款时需要取得您的认证,资金更安全":"Vincular 2FA para retiros más seguros",
    "立即绑定":"Vincular ahora",
    "请输入原绑定的谷歌验证码":"Ingrese el código de Google original",
    "重新绑定":"Revinculación",
    "交易密码":"Contraseña de transacción",
    "请输入交易密码":"Por favor ingrese la contraseña",
    "请输入谷歌验证码":"Por favor ingrese el código de Google",
    "请到安全中心设置交易密码":"Establezca la contraseña de transacción en el centro de seguridad",
    "请到安全中心设置谷歌验证":"Establezca la verificación de Google en el centro de seguridad",
    "请输入验证码":"Por favor ingrese el código",
    "信用分":"Crédito",
  "关闭":"Cerca",
  "查看详情":"Ver detalles",
  "向卖家付款":"Pagar al vendedor",
    "获取您的币种":"Consigue tu moneda",
    "我的订单":"Mis pedidos",
    "未匹配":"No coincide",
    "已匹配":"Emparejado",
    "已完成":"Terminado",
    "已过期":"Venció",
    "合同号":"Contrato N°",
      "买入金额":"Cantidad de compra",
      "邮箱":"Correo",
      "请输入您的电子邮箱":"Por favor ingrese su correo electrónico",
      "请选择购买的货币":"Por favor seleccione la moneda que desea comprar",
      "请选择支付的货币":"Por favor seleccione la moneda de pago",
      "请填写您的收款信息，如有需要补充信息请填写到备注栏或者联系客服。":"Por favor, rellene sus datos de pago. Si necesita información adicional, rellene la columna de observaciones o póngase en contacto con el servicio de atención al cliente.",
      "备注":"Observación",
      "请选择币种":"Por favor seleccione moneda",
      "请输入钱包地址":"Por favor, introduzca la dirección de su billetera",
      "绑定钱包":"Vincular billetera",
      "钱包地址":"Dirección de la billetera",
      "请输入备注":"Por favor, introduzca un comentario",
      "提现地址":"Dirección de retiro",
      "添加钱包地址":"Agregar dirección de billetera",
      "钱包管理":"Gestión de billetera",
    "重要提示：":"Consejos importantes:",
    "订单有效期：买方或卖方需在发起订单后3小时内完成交易。如未能完成，请及时联系在线客服确认订单状态。":"Plazo de validez del pedido: El comprador o vendedor deberá completar la transacción dentro de las 3 horas siguientes al inicio del pedido. Si no se puede completar, comuníquese con el servicio de atención al cliente en línea a tiempo para confirmar el estado del pedido.",
    "订单失效：若未在规定时间内联系客服，订单将自动失效，无法恢复。":"Vencimiento del pedido: Si no se comunica con el servicio de atención al cliente dentro del tiempo especificado, el pedido caducará automáticamente y no se podrá restaurar.",
    "安全保障：我们提供全面的交易保障措施，确保您的资金和交易信息安全。":"Seguridad: Brindamos medidas integrales de protección de transacciones para garantizar la seguridad de sus fondos y la información de sus transacciones.",

    "充值":"Depósito",
    "提现":"Retirar",
    "兑换":"Intercambio",
    "今日收益":"P&L(hoy)",
    "现金":"dinero",
    "交易":"comercio",
    "理财":"gestión financiera",
    "资产列表":"Lista de activos",
  "已锁仓":"Bloqueado",
  "最高可贷款":"Monto máximo prestable",
  "请先完成高级认证":"Complete la verificación avanzada",
  "贷款金额":"Monto del préstamo",
  "总还款额":"Reembolso total",
  "金融":"Finanzas",
  "选择周期":"Seleccionar ciclo",
  "选择类型":"Seleccionar tipo",
  "结算价":"Precio final",
  "限价卖出":"Venta límite",
  "截止价卖出":"Venta stop",
  "加密货币":"Cripto",
  "银行卡":"Carta bancaria",
  "金额":"Cantidad",
  "选择银行":"Seleccione Banco",
  "提款需要的手续费,这需要由网络节点确认, 才能记入请不要将加密货币转让给陌生人":"La tarifa de retiro debe ser confirmada por el nodo de la red antes de que se pueda acreditar. No transfiera criptomonedas a extraños",
  "银行卡管理":"Gestione conto bancario",
  "绑定银行卡":"Collega carta bancaria",
  "添加":"Agregar",
  "添加银行卡":"Añadir tarjeta bancaria",
  "修改银行卡":"Modificar tarjeta bancaria",
  "请添加银行卡":"Por favor agregue una tarjeta bancaria",
  "数量":"Cantidad",
  "继续下单":"Continuar",
  "路由号码":"路由号码",
  "请输入路由号码":"Por favor, introduzca un número de ruta",
  "搜索":"buscar",

  "限价买入":"Compra limitada",
  "截止价买入":"Compra con precio stop",
  "限价卖出":"Venta límite",
  "截止价卖出":"Venta stop",
  "贷款金额":"Monto del préstamo",
  "总还款额":"Reembolso total",
  "委托总量":"Total",
  "交易总额":"Monto total de la transacción",
  "成交价格":"Precio de la transacción",
  "委托价格":"Precio de comisión",
  "顶尖交易技术":"La mejor tecnología comercial",
  "通过我们的先进交易系统，您可以精准把握市场动态，高效执行每一笔交易！":"¡Con nuestro avanzado sistema de trading, puede capturar con precisión los movimientos del mercado y ejecutar cada operación de manera eficiente!",
  "累计收入":"Ingresos acumulados",
    "每日收益":"Ingresos diarios",
    "助您探索更多交易机会和":"Le ayudamos a explorar más oportunidades comerciales y",
    "金融产品":"Productos financieros",
    "什么是活期借贷？":"¿Qué es un préstamo a demanda?",
    "累计利息":"Interés acumulado",
    "申请金额":"Monto de la solicitud",
  "风险":"Riesgo",
  "审核结果":"Resultado de auditoría",
  "您的等级为":"Su nivel es",
  "未评估":"No evaluado",
  "谨慎性":"Conservador",
  "稳健型":"Moderado",
  "进取型":"Agresivo",
  "提示：您的风险承受为谨慎型，最高投资额为":"Consejo: Su tolerancia al riesgo es conservadora, y el monto máximo de inversión es",
  "如果您想提高额度请重新评估或联系客服":"Si desea aumentar el límite, vuelva a evaluar o contacte al servicio al cliente",
  "重新评估":"Reevaluar",
  "验证中,请耐心等待系统审核":"En verificación, por favor espere pacientemente la revisión del sistema",
  "确保符合平台的合规要求并完成您的投资者资格认证,我们需要您提供以下信息,请放心,您提供的所有资料将储存在我们高度加密和安全的资料库中,完全符合国际安全标准。我们非常重视您的资讯隐私,未经您的明确同意,绝不外泄或者分享这些资料":"Para cumplir con los requisitos de cumplimiento de la plataforma y completar su certificación de calificación de inversor, necesitamos que proporcione la siguiente información. Tenga la seguridad de que toda la información que proporcione se almacenará en nuestra base de datos altamente encriptada y segura, cumpliendo completamente con los estándares internacionales de seguridad. Valoramos mucho su privacidad y nunca compartiremos ni divulgaremos esta información sin su consentimiento explícito",
  "了解产品":"Conocer el producto",
  "C2C快捷买币只要三个":"La compra rápida de monedas C2C solo requiere tres",
  "步骤完成":"Pasos completados",
  "什么是C2C?":"¿Qué es C2C?",
  "请输入付款银行名称":"Por favor, introduzca el nombre del banco de pago",
  "请选择币种":"Por favor, seleccione la moneda",
  "查看订单":"Ver pedido",
  "查看汇款账号":"Ver la cuenta de transferencia",
  "订单金额":"Monto del pedido",
  "卖家收款账号":"Cuenta de cobro del vendedor",
  "账户名称":"Nombre de la cuenta",
  "账户号":"Número de cuenta",
  "银行名称":"Nombre del banco",
  "银行地址":"Dirección del banco",
  "距离本次电汇订单有效期还剩":"Tiempo restante para la validez de esta orden de transferencia bancaria",
  "买入金额":"Monto de compra",
  "查看汇款账号":"Ver la cuenta de transferencia",
  "请输入订单号":"Por favor, introduzca el número de pedido",
  "职业":"Profesión",
  "请输入职业":"Por favor, introduzca su profesión",
  "财富来源":"Fuente de riqueza",
  "请输入财富来源":"Por favor, introduzca la fuente de riqueza",
  "预期投资金额":"Monto de inversión previsto",
  "请输入预期投资金额":"Por favor, introduzca el monto de inversión previsto",
  "资产证明":"Prueba de activos",
  "请上传资产证明":"Por favor, suba la prueba de activos",
  "借贷":"Préstamo",
  "我的贷款订单":"Mis órdenes de préstamo",
  "借贷金额":"Monto del préstamo",
  "可借额度":"Límite de préstamo disponible",
  "借贷天数":"Días del préstamo",
  "请选择天数":"Por favor, seleccione los días",
  "立即借币":"Solicitar préstamo inmediatamente",
  "当前借贷":"Préstamo actual",
  "当前信用分":"Puntuación de crédito actual",
  "还款总额":"Monto total a reembolsar",
  "还款日期":"Fecha de reembolso",
  "产品亮点":"Aspectos destacados del producto",
  "超低利息":"Intereses ultrabajos",
  "为了回馈新老用户，平台借贷超低利息费用":"Para recompensar a los usuarios nuevos y antiguos, la plataforma ofrece tasas de interés ultrabajas en los préstamos",
  "当天下发":"Desembolso el mismo día",
  "当天贷款，最快当天下发至您的账户里":"Préstamo el mismo día, con desembolso más rápido en su cuenta",
  "24小时在线客服":"Atención al cliente en línea las 24 horas",
  "24小时在线客服，满足您的贷款需求":"Atención al cliente en línea las 24 horas para satisfacer sus necesidades de préstamo",
  "产品规则":"Reglas del producto",
  "单位":"Unidad",
  "获利":"Ganancia",
  "稳健型ETF订单":"Orden de ETF moderado",
  "低风险ETF订单":"Orden de ETF de bajo riesgo",
  "VIP理财订单":"Orden VIP de gestión financiera",
  "输入地址":"Introducir dirección",
  "购买":"Comprar",
  "当前可用":"Actualmente disponible",
  "请验证您的助记词以确认钱包所有权,然后提交您的加密地址":"Por favor, verifique su frase de recuperación para confirmar la propiedad de la billetera, luego envíe su dirección encriptada",
  "地址":"Dirección",
  "验证码助记词":"Frase de recuperación para verificación",
  "产品亮点":"Aspectos destacados del producto",
  "100%资金安全保障":"Garantía de seguridad del 100% de los fondos",
  "我们致力于确保金融产品和服务对投资者公平":"Nos comprometemos a garantizar que los productos y servicios financieros sean justos para los inversores",
  "正规平台受政府监管":"Plataforma regulada por el gobierno",
  "我们主动接受各级政府监管和合规经营":"Nos sometemos activamente a la supervisión y cumplimiento de todos los niveles del gobierno",
  "当天起息":"Intereses desde el mismo día",
  "当天成功存入后，马上计算收益":"Los ingresos se calculan inmediatamente después del depósito exitoso el mismo día",
  "加密钱包地址":"Dirección de billetera encriptada",
  "请输入助记词":"Por favor, introduzca la frase de recuperación",
  "助记词无效":"Frase de recuperación inválida",
  "请输入钱包地址":"Por favor, introduzca la dirección de la billetera",

  "存储人姓名":"Nombre del depositante",
  "付款银行名称":"Nombre del banco pagador",
  "买卖币种":"Compra y venta de divisas",
  "选择币种":"Seleccione moneda",
  "付款方式":"Métodos de pago",
  "法币":"Dinero fiduciario",
  "电汇":"T/T",
  "输入法币":"Ingrese moneda fiduciaria",
  "存款金额":"Monto del depósito",
  "请输入金额":"Por favor ingrese la cantidad",
  "上传汇款凭证":"Subir una copia de la transferencia",
  "请输入订单号":"Por favor, introduzca su número de pedido",
  "低风险":"Riesgo bajo",
  "稳健型":"Robusto",
  "基金":"Financiar",
  "类型":"Tipo",
  "输入":"Ingresar",
  "立即参与":"Unirse Ahora",
  "什么是低风险ETF?":"¿Qué son los ETF de bajo riesgo?",
  "什么是稳健型ETF?":"¿Qué es un ETF conservador?",
  "什么是VIP理财？":"¿Qué es VIP Financial Management?",
  "买币流程":"Proceso de compra de moneda",
  "创建预订单":"Crear preorden",
  "联系客服":"servicio al cliente",
  "提交凭证":"certificado",
  "创建订单":"Crear orden",
  "我们的优势":"Nuestras ventajas",
  "低廉的交易费用":"Baja tarifa de transacción",
  "在我们的C2C买币上，下单方以零手续费交易，我承诺在所有市场用最低的C2C交易费用":"En nuestra moneda de compra C2C, la parte ordenante comercia con cero tarifas de transacción. Prometemos aplicar las tarifas de transacción C2C más bajas en todos los mercados.",
  "多种支付方式":"Múltiples métodos de pago",
  "点对点（C2C）交易允许卖家自由定义透明想要的付款方式，通过700多种支付方式买卖加密货币，包括银行转账、现金。":"El comercio entre pares (C2C) permite a los vendedores definir libremente el método de pago que desean. Compre y venda criptomonedas con más de 700 métodos de pago, incluidas transferencias bancarias, efectivo.",
  "以您喜欢的价格交易":"Comercie al precio que prefiera",
  "以您喜欢的价格自由买卖加密货币，从现有报价中买卖，或创建交易广告来设置您理想的价格":"Gratis para comprar y vender criptomonedas al precio que desee, comprar y vender ofertas existentes o crear un anuncio comercial para establecer su precio ideal",
  "C2C简介":"Introducción al C2C",
  "开":"O",
  "收":"C",
  "高":"H",
  "低":"L",
  "指标":"Indicador",
  "订单表":"Libro de órdenes",
  "最新成交":"Últimas operaciones",
  "截止价":"Precio de stop-out",
  "风险评估":"Questionario",
  "C2C买币":"Compra de monedas C2C",
  "初级认证":"Certificación primaria",
  "高级认证":"Certificación avanzada",
  "升级":"Actualización",
  "新币":"Startup",
  "全仓":"Almacén completo",
  "可开数量":"Cantidad disponible",
  "现货交易":"Spot",
  "当前委托":"Pedido actual",
  "历史委托":"Pedido histórico",
  "投资组合":"Cartera",
  "分配":"distribuir",
  "投资":"gestión financiera",
  "隐藏小额资产":"Ocultar activos pequeños",
  "个人中心":"centro personal",
  "交易手续费":"Tarifas de transacción",
  "实时新闻":"Noticias",
  "联系客服匹配订单":"Póngase en contacto con el servicio de atención al cliente para hacer coincidir los pedidos",
  "分":"m",
  "时":"h",
  "天":"d",
  "周":"w",
  "月":"Month",
  "年":"Year",
  "我的投资":"Registro",
  "总投入":"Inversión total",
  "待匹配":"Partido pendiente",
  "已匹配":"Emparejado",
  "已完成":"Terminado",
  "已拒绝":"Rechazado",
  "付款人姓名":"Nombre del pagador",
  "请输入付款银行名称":"Introduzca el nombre del banco pagador",
  "新币申购":"Nueva oferta de monedas",
  "会员投资产品":"Productos de gestión patrimonial",
  "默认":"por defecto",
  "个人主页":"Página de inicio personal",
  "住址":"DIRECCIÓN",
  "街道、楼号":"Calle, Edificio No.",
  "职业":"Ocupación",
  "请填写职业":"Por favor complete la ocupación",
  "月收入":"Ingresos mensuales",
  "请输入月收入":"Por favor ingrese el ingreso mensual",
  "财富来源":"Fuente de riqueza",
  "请输入财富来源":"Por favor ingrese su fuente de riqueza",
  "预期投资资金":"Fondos de inversión esperados",
  "请输入预期投资资金":"Por favor ingrese el monto de inversión esperado",
  "资产证明":"Prueba de activos",
  "房屋证明":"Prueba de casa",
  "银行存款证明":"Comprobante de depósito bancario",
  "股票":"Cepo",
  "持有的公司证明":"Certificado de empresa en posesión",
  "上传证明":"Subir prueba",
  "提交":"Entregar",
  "VIP财务管理":"Finanzas VIP",
  "顶尖交易技术":"La mejor tecnología comercial",
  "通过我们的先进交易系统，您可以精准把握市场动态，高效执行每一笔交易！":"¡Con nuestro avanzado sistema de trading, puede capturar con precisión los movimientos del mercado y ejecutar cada operación de manera eficiente!",
  "搬砖币种":"Moneda de ladrillo",
  "VIP理财":"VIP Financiero",
  "支付信息":"Payment",
  "上传凭证":"Cargar comprobantes",
  "支付方式":"Método de pago",
  "继续":"Continuar",
  "钱包地址":"Indirizzo del portafoglio",
  "请填写地址":"Ingrese la dirección de la billetera",
  "累计收入":"Ingresos acumulados",
  "每日收益":"Ingresos diarios",
      "估值":"Valuation",
  "收益率":"Tasa de Rendimiento",
      "钱包":"billetera",
      "账户":"Cuenta",
      "投资金额":"Monto de inversión",
      "提交助记词":"Enviar frase mnemotécnica",
      "请验证助记词以确认钱包所有权，并提交加密地址":"Verifique su mnemotécnico para confirmar la propiedad de la billetera y envíe su dirección de criptomoneda.",
      "验证助记词":"Verificar frase mnemotécnica",
      "确认":"confirmar",
      "请填写数量":"Complete la cantidad",
      "1.初始连接web3":"Conexión inicial a web3",
      "2.建立区块链节点":"Establecer un nodo blockchain",
      "3.建立智能合约网络":"Establecer una red de contratos inteligentes",
      "4.成功创建合约":"Cree con éxito el contrato.",
      "5.启动验证":"Iniciar la verificación",
      "可开仓":"Apribile",
      "语言":"Idioma",
      "交易明细":"Detalles comerciales",
      "杠杆倍数":"Apalancamiento",
      "保证金":"Margen",
      "手续费":"Comisión",
      "剩余保证金":"Margen restante",
      "开仓价格":"Precio de entrada",
      "开仓时间":"Tiempo de apertura",
      "盈亏":"Ganancias/pérdidas",
      "交易周期":"Duración",
      "交易时间":"Marca de tiempo",
      "托管中":"Hospedaje",
      "已赎回":"Canjeado",
      "请输入付款银行名称":"Ingrese el nombre del banco de pago.",
      "请进行初级认证":"Si prega di fare la certificazione primaria",
      "请进行高级认证":"Por favor, realice una certificación avanzada",
      "重新认证":"Recertificar",
      "查看汇款账号":"Ver cuenta de remesa",
      "电汇订单剩余有效期":"Validez del pedido T/T",
      "卖家收款账号":"Cuenta del vendedor",
      "账户名称":"Nombre de la cuenta",
      "账户号":"Número de cuenta",
      "复制":"Copiar",
      "订单有效期为3小时，过期请联系客服":"Orden válida por 3 horas, comuníquese con el servicio de asistencia si vence",
      "请上传汇款凭证":"Por favor subir el comprobante de remesa",
      "SWIFT代码":"Código SWIFT",
      "限价":"Límite",
      "限价买入":"Compra limitada",
      "截止价买入":"Compra con precio stop",
      "提示：您的风险评估为":"Consejo: Su evaluación de riesgos es",
      "请输入限价":"Por favor, introduzca el precio límite",
      "昨日收益":"Beneficio de ayer",
      "期权交易":"Opción",
      "历史持仓":"Histórica",
      "托管数量":"Cantidad",
  "dcwj":{
  	"homehq1":"Explora criptomonedas, forex, metales preciosos y más",
  	"homehq2":"Compre, venda y administre cientos de categorías comerciales de manera simple y segura",
  	"homehq3":"Ver más activos",
  	"xbgm":"Preste atención al momento de comprar monedas nuevas. No puede comprarlas cuando caduquen.",
  	"yzmjs":"Código de verificación recibido",
  	"jhzh":"Activar cuenta",
  	"xyy":"Página siguiente",
  	"qxz":"Por favor seleccione",
    },
  "立即兑换":"Canjear ahora",
  "获得":"adquisición",
  "消耗":"agotar",
  "jhzf":"Enviamos un código de verificación a {0}. Úselo para activar su cuenta.",
  "一应俱全的金融交易体验":"Amplia experiencia en operaciones financieras",
    "强大平台,超低点差,快速执行,专属支持":"Plataforma potente, spreads ultrabajos, ejecución rápida, soporte exclusivo",
    "您可以信赖的经济人":"Un agente en el que puede confiar",
    "卓越的客户服务、透明的定价和最先进的平台方面建 立了卓越的声誉":"Reputación establecida por su excepcional servicio al cliente, precios transparentes y plataforma de última generación.",
    "强大的交易技术专属体验":"Potente experiencia exclusiva en tecnología comercial",
    "与整体满意度最高的供应商交易差价合约，把握更好的交易时机":"Opere con CFD con proveedores con la mayor satisfacción general para obtener mejores oportunidades comerciales",
    "为什么选择FXLY？让我们的数字来说话":"Por qué operar con FXLY.com? Nuestros números hablan por nosotros",
  "还在找一位您可以信任的经纪商吗？":"Aún estás buscando un bróker de confianza?",
    "1.创建和验证您的账户":"1. Crea y verifica tu cuenta",
    "2.进行存款":"2. Realiza un depósito",
    "3.找到合适您的交易":"3. Detecta oportunidades de trading",
  "交易者":"Comerciantes",
    "每月活跃客户":"Clientes activos mensualmente",
    "每月交易量":"Volumen mensual deoperaciones",
    "每月提取金额":"Retiros por mes",
    "加入成为全球660,000万多名交易者的一份子，选择利用FXLY.com进行交易吧。":"Únete a más de 660,000 traders de todo el mundo que eligen operar con FXLY.com",
  "国家":"País",
    "首页":"Hogar",
    "交易市场":"Mercados",
    "市场概览":"Introducción",
    "股票":"Acciones",
    "外汇":"Forex",
    "商品":"Materias primas",
    "加密货币":"Cripto",
    "币币交易":"Comercio de divisas",
    "合约交易":"Comercio por contrato",
    "期权交易":"Comercio de opciones",
    "教育":"Educación",
    "市场指南":"Guías de mercados",
    "股票交易":"Trading de acciones",
    "商品交易":"Trading de materias primas",
    "外汇交易":"Trading de divisas",
    "加密货币交易":"Trading de cripto",
    "学习中心":"centro educativo",
    "交易基础知识":"Lo esencial",
    "什么是差价合约":"Qué es un CFD",
    "交易术语表":"Glosario de trading",
    "交易策略指南":"Guía de trading",
    "更多":"Ver más",
    "新闻":"Noticias",
    "热点新闻":"Noticias de actualidad",
    "关于我们":"Sobre nosotros",
    "为何选择我们":"Elíjanosxs",
    "如何保证安全性":"Garantizar la seguridad",
    "合规与法律":"Cumplimiento y aviso legal",
    "服务费用":"Tarifas de servicio",
    "投诉程序":"Procedimiento de quejas",
    "条款政策":"Términos condiciones",
    "帮助与支持":"Atención al cliente",
    "指数":"Índices",
    "请切换到真实账户":"Por favor, cambie a cuentas en vivo",
  "支持桌面端与移动端多种方式":"Admite múltiples métodos en terminales móviles y de escritorio",
  "简单、快速、安全、合法":"Sencillo, rápido, seguro y legal",
  "免费客户咨询服务":"Servicio gratuito de consulta al cliente.",
  "多种产品可供选择":"Amplia gama de productos para elegir.",
  "下载应用程序":"Descargar aplicación",
  "24小时交易量":"Volumen de operaciones las 24 horas",
  "币种":"Divisa",
  "交易者":"Comerciante",
  "每月提取金额":"Monto de retiro mensual",
  "亿":"B",
  "万":"M",
  "3000多种品类供您选择":"Más de 3.000 categorías para que elijas",
  "操作不熟练,试试模拟交易":"Si no tiene experiencia en la operación, pruebe el comercio simulado.",
  "线上交易,请选择":"Para transacciones en línea, seleccione",
  "交易所":"intercambio",
  "3000多种品类,包括加密货币,贵金属,外汇, 原油等等":"Más de 3.000 categorías, incluidas criptomonedas, metales preciosos, divisas, petróleo crudo, etc.",
  "立即交易":"Opere ahora",
  "希望增进您的交易技巧":"Quiere mejorar sus habilidades comerciales",
  "访问我们的帮助中心,获取全面交易指南":"Visite nuestro Centro de ayuda para obtener guías comerciales completas",
  "去看看":"Ve y echa un vistazo",
  "操作不熟练,试试我们的模拟交易功能":"Si no tiene experiencia en la operación, pruebe nuestra función de negociación simulada",
  "免费体验交易,让您尽快上手":"Intente operar gratis para poder comenzar lo antes posible",
  "马上体验":"Pruébalo ahora",
  "充币":"depositar monedas",
  "提币":"retirar monedas",
  "客服":"servicio al cliente",
  "更多":"Más",
  "热门品种":"Variedades populares",
  "卖出":"vender",
  "买入":"comprar",
  "了解我们的平台":"Conoce nuestra plataforma",
  "直观易用":"Intuitivo y fácil de usar",
  "的界面":"interfaz",
  "定期提供":"Proporcionado regularmente",
  "3,000多个市场":"Más de 3000 mercados",
  "的实时更新和 价格警报":"Actualizaciones en vivo y alertas de precios para",
  "各种技术指标":"Varios indicadores técnicos.",
  "分析工具和高级图表":"Herramientas de análisis y gráficos avanzados.",
  "套期保值模式和":"modelo de cobertura y",
  "风险管理工具":"herramientas de gestión de riesgos",
  "我们创建了技术领先且人性化的交易平台 ,为您提供贴心完善的交易体验":"Hemos creado una plataforma comercial tecnológicamente avanzada y fácil de usar para brindarle una experiencia comercial considerada y completa.",
  "实时新闻咨询":"Consulta de noticias en tiempo real.",
  "紧跟我们的新闻、产品和活动信息":"Manténgase al día con nuestras noticias, productos y eventos.",
  "阅读更多新闻":"Leer más noticias",
  "合作伙伴等最新新闻动态":"Últimas noticias sobre socios y más",
  "AI智能赚币":"Ganar dinero inteligentemente con IA",
  "出金":"Retirar fondos",
  "随存随取":"Deposita y retira en cualquier momento",
  "一键即刻取出,从不等待":"Sácalo inmediatamente con un clic, nunca esperes",
  "稳定":"Estabilizar",
  "最稳健的理财":"La gestión financiera más estable",
  "稳定收益,您的理财助手":"Ingresos estables, su asistente financiero",
  "执行速度":"Velocidad de ejecución",
  "极速执行":"Ejecución extremadamente rápida",
  "所有订单将以毫秒级别速度执行":"Todas las órdenes se ejecutarán a una velocidad de milisegundos.",
  "每天发放":"Distribuido todos los días",
  "当天产生收益":"Beneficio generado en el día.",
  "当天购买当天产生收益,24小时及时发放收益":"Los ingresos se generarán el mismo día de la compra y se distribuirán puntualmente las 24 horas del día.",
  "现在就开始":"empezar ahora",
  "交易全球金融市场":"Opere en los mercados financieros globales",
  "支持桌面端与移动端多种方式,您可随时 随地开展交易":"Admite múltiples métodos en terminales móviles y de escritorio, puede realizar transacciones en cualquier momento y en cualquier lugar",
  "谷歌下载":"descargar google",
  "下载":"descargar",
  "公司":"compañía",
  "关于我们":"sobre nosotros",
  "许可证监督":"Supervisión de licencia",
  "帮助中心":"Centro de ayuda",
  "政策":"política",
  "条款与条件":"Términos condiciones",
  "隐私政策":"política de privacidad",
  "声明":"declaración",
  "法律信息":"información legal",
  "免责声明":"Descargo de responsabilidad",
  "风险警告":"Advertencia de riesgo",
  "关于广告":"Acerca de la publicidad",
  "总持仓":"Posiciones totales",
  "总收益":"Ingresos totales",
  "选择充币币种":"Seleccionar moneda de depósito",
  "各币种最小充值数量":"El monto mínimo de depósito de cada moneda: 1 USDT, 0.001 BTC, 0.1 ETH, 10 TRX. Si el monto es menor que este monto, usted será responsable de la imposibilidad de llegar con precisión a su cuenta.",
  "充币地址":"Dirección de depósito",
  "图片上传提示1":"Coloque su imagen aquí o navegue",
  "图片上传提示2":"Soporte: JPG, JPEG2000, PNG",
  "搜索币种":"Buscar moneda",
  "选择提币币种":"Seleccione la moneda de retiro",
  "最低提币数量":"Monto mínimo de retiro: ",
  "小于最低提币数量不能进行提币":"Las monedas no se pueden retirar si el monto es menor que el monto mínimo de retiro",
  "为保障资金安全":"• Para garantizar la seguridad de sus fondos, cuando la política de seguridad de su cuenta cambie o se modifique su contraseña, realizaremos una revisión manual del retiro. Tenga paciencia y espere a que el personal se comunique con usted por teléfono o correo electrónico.",
  "请务必确认电脑及浏览器安全":"• Asegúrese de que su computadora y su navegador sean seguros para evitar que la información sea manipulada o filtrada.",
  "您所提的数字资产为一币多链资产":"• Los activos digitales que retira son activos de múltiples cadenas de una moneda. No importa de qué cadena elija retirar, significa que la cantidad total de activos digitales que se muestran en la página de retiro que posee se reduce en el monto de retiro correspondiente.",
  "提币地址":"Dirección de retiro de monedas...",
  currency: {
    bb: 'Intercambio',
    bba: 'Cuenta de intercambio',
    hy: 'Contrato',
    jg: 'Opción',
    jg1: 'Futuros',
    hya: 'Cuenta Contrato'
  },
  home:{
    user:'Elección común de usuarios',
    start:'Comienza a negociar',
    trading:'Productos comerciales',
    fee:'Tarifa mínima de manipulación',
    co:'Co',
    varieties:'Variedades comerciales',
    leading:'Liderando la innovación y exploración de web3',
    market:'Tendencias del mercado de productos comerciales.',
    explore:'Explora infinitas posibilidades',
    newcurrency:'¡La nueva función de suscripción de moneda está en línea!',
    alimited:'Hay nuevas monedas en línea, puedes comprar nuevas monedas que creas que tienen potencial aquí',
    get_start:'Comenzar',
    ai_coin:'El plan de obtención de monedas de IA está en marcha',
    ai_text:'Comience a ganar monedas con IA, ingresos estables, alta tasa de rendimiento, lo que le permite ganar monedas mientras está acostado.',
    loan:'La función de préstamo está en línea.',
    loan_text:'Cuando no tengas dinero, puedes solicitar un préstamo y se emitirá tan pronto como el mismo día.',
    mobile_pc:'Utilizado por enfermeras en PC móviles',
    pc_anytime:'Comience a operar en cualquier momento y en cualquier lugar:',
    pc_text:'Proporcionamos potentes herramientas de análisis de gráficos: más de cincuenta indicadores técnicos y herramientas de análisis de discos. El apalancamiento seguro, confiable, fácil de usar y las funciones de alto apalancamiento se han convertido en la plataforma estándar para la inversión en línea.',
    mobile_down:'haga clic para descargar',
    mobile_android:'Mercado Android',
    mobile_ios:'tienda Apple',
    open_text:'Puede solicitar una cuenta comercial real o probar una cuenta de demostración de forma gratuita por un tercio del costo.',
    open_account:'una cuenta',
    tocomplete:'completar',
    walletlogin:'Inicio de sesión de billetera'
  },
  index: {
    h24: 'Volumen 24H',
    header_title: ['Elija el comercio de activos digitales ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'Transacción completa de activos digitales blockchain de ventanilla única',
    header_msg: 'Seguro-estable-confiable',
    register_title: 'Registrar un ' + window.GLOBAL.LANG_TITLE.zh + ' la cuenta global comienza el viaje comercial',
    register_pl: 'Por favor, introduzca su correo electrónico o número de móvil',
    register: 'Regístrese',
    featureTitleWhy: 'Elíjanosxs',
    featureTitle: 'Seguro · estable · confiable',
    featureMsg: '',
    featureList: [
      { icon: icon1, title: 'Tecnología de billetera segura', msg: ['La tecnología de billetera fría y caliente es desarrollada por el mejor equipo de seguridad del mundo, y nunca ha habido un incidente de pérdida de monedas.',''] },
      { icon: icon2, title: 'Negocio rico en activos criptográficos', msg: ['Apoyar el comercio de derivados múltiples y al contado, etc., es su administrador personal en el mundo de los activos cifrados.',''] },
      { icon: icon3, title: 'Clientes distribuidos por todo el mundo', msg: ['Proporcione una gama completa de servicios de activos cifrados para usuarios en más de 130 países o regiones de todo el mundo.', ''] }
    ],
    bannerList: [
      {icon: banner01, title: "Comprometidos con proporcionar seguridad y estabilidad líderes en la industria", msg:["contratos inteligentes para proteger la seguridad de los activos de los inversores", "rendimiento comercial real", "garantía de servicio las 24 horas"]},
      {icon: banner02, title: "Quiero comprar y vender de inmediato mediante operaciones simples", msg:["pantalla de negociación simple", "reflejada inmediatamente en el saldo de su cuenta", "la mayoría de las criptomonedas se pueden comercializar"]},
      {icon: banner03, title: "Quiero obtener beneficios de forma activa mediante la negociación de contratos de liquidación", msg:["Abra una cuenta al mismo tiempo", "Inversión estratégica para una gran cantidad de futuros de negociación", "Puede negociar 24 horas al día, 365 días al año, incluso los fines de semana "]}
    ],
    featureList2: [
      {icon: icon1_01, title: "Transparencia y apertura", msg:["Uso de las características de blockchain y contratos inteligentes, realización de transacciones en la cadena y uso de contratos inteligentes para garantizar la seguridad de los activos de los inversores", ""] },
      {icon: icon1_02, title: "Inversión inteligente", msg:["Con las estrategias diversificadas proporcionadas por los mejores expertos en comercio cuantitativo, puede elegir", ""]},
      {icon: icon1_03, title: "Calificación de riesgo", msg:["Diseñe productos de inversión diversificados basados ​​en los diferentes riesgos y preferencias de administración de activos de cada inversor, eliminando efectivamente los umbrales de inversión", ""]},
      {icon: icon1_04, title: "Productos diversificados", msg:["Proporcione varios tipos de necesidades de inversión de los usuarios y mecanismos de plataforma flexibles, y continúe produciendo servicios financieros innovadores que sean mejores que el mercado", ""]}
    ],
    featureTitle2: 'Transacción de terminal multiplataforma en cualquier momento y en cualquier lugar',
    featureMsg2: 'Cubriendo múltiples plataformas de iOS y Android, compatible con funciones de servicio completo',
    tab: ['Moneda convencional', 'Lista de aumento 24H'],
    thead: ['Par', 'Último precio', 'Precio más alto del día', 'Precio más bajo del día', 'Aumentar lista', 'Volumen 24H', 'operando'],
    more: 'Cargar más >',
    btn: 'Intercambio',
    dealsTitle: 'Servicio de comercio todo en uno',
    dealsTab:[
      { title: 'Intercambio', content: 'El intercambio tiene como objetivo el intercambio entre activos digitales, utilizando USDT como unidad de valoración para comprar otras monedas.'+window.GLOBAL.LANG_TITLE.zh+'Admite transacciones en tiempo real de activos digitales como Bitcoin, Ethereum y Litecoin.', src:'/static/image/deals-1.jpg', path: '' },
      { title: 'Contrato', content: 'Un derivado financiero de una moneda digital no solo admite la opción de comprar contratos de venta largos o cortos para obtener ingresos, sino que también es fácil de operar y nunca caduca.'+window.GLOBAL.LANG_TITLE.zh+'El contrato cuenta con un avanzado sistema de gestión de riesgos con apalancamiento de hasta 100 veces.', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['Opcional', 'Contrato', 'Intercambio'],
    thead: ['Moneda', 'Último precio', 'Cambio 24H', 'Mínimo 24 horas', '24H más alto','Volumen 24H', 'operando'],
    nodata: 'Sin datos'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "Sobre nosotros",
        dd: [{ title: "Perfil de la empresa", id: 1 }, { title: "Centro de ayuda", type: 'help' }]
      },
      {
        dt: "Soporte al usuario",
        dd: [
          { title: "Acuerdo del Usuario", id: 3 },
          { title: "Política de privacidad", id: 5 }
        ]
      },
      {
        dt: "Contáctenos",
        icon: true
      }
    ],
    terms: "Términos condiciones",
    serve: "Atender",
    product: "producto",
  },
  nav: {
    btn: ["iniciar sesión", "Regístrese", "gestión de activos","Descargar la aplicación"],
    nav: [
      { title: "Inicio", path: "/index",name: 'index' },
      // { title: "Intercambio", path: "/deal",name: 'deal' },
      { title: "Mercado", path: "/market",name: 'market' },
      { title: "Comercio", path: "/preciousMetal", name: 'preciousMetal'},
      // { title: "Intercambio", path: "/deal", name: 'deal'},
      // { title: "Contrato", path: "/deal_c", name: 'deal_c' },
      // { title: "Criptomoneda", path: "/deal_jg", name: 'deal_jg' },
      // { title: "AI Ganar monedas", path: "/profit_index",name: 'profit_index' },
      { title: "Financiera", path: "/profit_index",name: 'profit_index' },
      // { title: "Actividades", path: "/sign",name: 'sign' }
    ],
    nav2: [{ title: "Mis activos", path: "/asset" }],
    menus: [
      { icon: langzh, title: "Centro de usuarios", path: "/setting" },
      { icon: langen, title: "desconectar" }
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      { icon: langxby, lang: "España", key: 'xby' },
      // { icon: langfy, lang: "français", key: 'fy' },
      // { icon: langdy, lang: "Deutsche", key: 'dy' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      // { icon: langar, lang: "عربي", key: 'ar' },
      { icon: langhy, lang: "한국어", key: 'hy' },
      { icon: langty, lang: "ไทย", key: 'ty' },
      { icon: langyn, lang: "Tiếng Việt", key: 'yn' },
      { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'ft' },
    ]
  },
  download:{
    "xz": "descargar"
  },
  // 登录
  // login: {
  //   login: 'Ingresa, por favor',
  //   msg: 'Ingrese su cuenta registrada',
  //   list: ['móvil / correo electrónico', 'Contraseña', '¿Ha olvidado su contraseña?', 'iniciar sesión', 'Sin cuenta, regístrese ahora'],
  //   message: 'La cuenta o la contraseña no pueden estar vacías'
  // },
  register: {
    dl: ['Inscripción móvil', 'Inscripción por correo electrónico'],
    title: 'Registrar una cuenta',
    country: 'País de ciudadanía',
    country_info: 'La información de nacionalidad no se puede modificar después del registro, asegúrese de elegir la verdad',
    account: 'cuenta',
    code_text: 'Código de verificación',
    code_btn: 'Obtener CAPTCHA',
    code_btn1: 'Retransmisión',
    code_unit: 's',
    code_no_data: 'se debe completar el código de verificación',
    password_text: 'Contraseña',
    password_again_text: 'Contraseña de nuevo',
    pid_text: 'Código de invitación',
    pid_pl: 'Opcional',
    invitation_code_no_data: 'Se requiere el código de invitación',
    xy: 'Acuerdo del Usuario',
    xy_no_checked: 'Por favor seleccione acuerdo',
    agree: 'He leído y estoy de acuerdo',
    register_btn: 'Regístrese',
    bz: ['La información de nacionalidad no se puede modificar después del registro, asegúrese de elegir con sinceridad.', 'Es posible que el correo electrónico de verificación se califique erróneamente como correo no deseado; revíselo con atención.', 'Por favor guarde su' + window.GLOBAL.LANG_TITLE.zh + 'Número de cuenta y contraseña de inicio de sesión.', 'No utilice la misma contraseña de inicio de sesión que otros sitios web.'],
    account_no_data: 'La cuenta no puede estar vacía',
    code_no_equality: 'Los códigos de verificación no son iguales',
    password_no_data: 'la contraseña no puede estar en blanco',
    password_no_equality: 'Las dos contraseñas no son iguales'
  },
  // 设置密码
  bindmpwd: {
    title: 'configurar la clave',
    account: 'cuenta',
    code_text: 'Código de verificación',
    code_btn: 'Obtener CAPTCHA',
    code_unit: 's',
    password_text: 'Contraseña',
    password_again_text: 'Contraseña de nuevo',
    code_no_data: 'se debe completar el código de verificación',
    code_no_equality: 'Los códigos de verificación no son iguales',
    password_no_data: 'la contraseña no puede estar en blanco',
    password_no_equality: 'Las dos contraseñas no son iguales',
    bindmpwd_btn: 'Confirmar',
    phone_no_data: 'El número de teléfono no puede estar en blanco',
    password_login_text: 'Introducir la contraseña de acceso',
    password_trade_text: 'Longitud de la contraseña 6 dígitos',
    password_again_tarde_text: 'Longitud de la contraseña 6 dígitos',
  },
  // 忘记密码
  forgetpwd: {
    title: ['cambiar la contraseña', 'Se te olvidó tu contraseña'],
    account: 'cuenta',
    code_text: 'Código de verificación',
    code_btn: 'Obtener CAPTCHA',
    code_unit: 's',
    password_text: 'Contraseña',
    password_again_text: 'Contraseña de nuevo',

    phone_no_data: 'El número de teléfono no puede estar en blanco',

    account_no_data: 'La cuenta no puede estar vacía',
    code_no_data: 'se debe completar el código de verificación',
    code_no_equality: 'Los códigos de verificación no son iguales',
    password_no_data: 'la contraseña no puede estar en blanco',
    password_no_equality: 'Las dos contraseñas no son iguales',
    forgetpwd_btn: 'Confirmar'
  },
  // 绑定手机号码
  bindphone: {
    title: 'Vincular número de teléfono móvil',
    phone_text: 'número de teléfono',
  },
  person: {
    more: 'Cargar más',
    no_more: 'Sin datos',
    index_center:"Centro de usuarios",
    index_menus: [
      { icon: zhsz, title: "Administración de cuentas", path: '/setting' },
      { icon: sfrz, title: "Autenticación KYC", path: '/sfyz' },
      { icon: sfrz, title: "Certificación junior", path: '/smauth' },
      { icon: sfrz, title: "Autenticación", path: '/seniorauth' },
      { icon: jtrz, title: "Autenticación de dirección", path: '/dzrz' },
      { icon: jtrz, title: "Comprar criptografía", path: '/kjmbSelect' },
      { icon: jtrz, title: "Puntaje de credito", path: '/credit' },
      { icon: jtrz, title: "Registros", path: '/deallog' },
      { icon: jtrz, title: "Registro de depósito", path: '/cbjl' },
      { icon: jtrz, title: "Registro de retiros", path: '/tbjl' },
    ],
    cbtb: 'Depósito y retirada',
    jymx: 'Detalles de la transacción',
    xyf: {
      'title': 'Puntaje de credito',
      'pgsj': 'Tiempo de evaluación'
    },
    smrz:{
       title:'KYC' ,
       sure_title:'Has sido autenticado',
       zj_type:'Tipos de documentos de indentidad válidos' ,
       zj_info:['1. La información de certificación no se puede modificar una vez verificada, por favor complete con la verdad','2. La información autenticada del nombre real no se puede volver a autenticar'],
       zj_name:'Nombre' ,
       zj_num:'Número del documento de indentidad' ,
       zj_btn:'ACEPTAR' ,
       zj_rebtn:'Vuelva a verificar' ,
       zj_sebtn:'Certificación senior' ,
       zj_type_array:[{name:'documento de indentidad de identidad',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "documento de indentidad de identidad"
        },
        {
            id: 2,
            name: "Pasaporte"
        },
        {
            id: 3,
            name: "Licencia de conducir"
        },
        {
            id: 4,
            name: "permiso de residencia"
        },
        {
            id: 5,
            name: "Otro tipo de documentos identificativos"
        }
       ],
       zj_data:{city:'La nacionalidad no puede estar vacía',type:'El tipo de credencial no puede estar vacío',name:'El nombre no puede estar vacío',zj_num:'El número de identificación no puede estar vacío'},
       zsxm: 'Nombre real',
       qsrzsxm: 'Por favor, introduzca su nombre real',
       zjlx: 'Tipos de documentos de indentidad válidos',
       qxzzjlx: 'Seleccione el tipo de documento de identidad',
       sfz: 'documento de indentidad de identidad',
       zjhm: 'Número del documento de indentidad',
       qsrzjhm: 'Por favor, introduzca el número del documento de indentidad',
       sczjz: 'Subir fotos del documento de identidad',
       zjzm: 'Subir foto del anverso del documento de identidad',
       zjfm: 'Subir foto del reverso del documento de identidad',
       qsczjzm: 'Subir foto del anverso del documento de identidad',
       qsczjfm: 'Subir foto del reverso del documento de identidad',
       scqmz: 'Subir documentos de identidad y firma personal',
       qscscqmz: 'Subir documentos de identidad y firma personal',
       zj: [
         {
           id: 1,
           title: 'documento de indentidad de identidad'
         },
         {
           id: 2,
           title: 'Pasaporte'
         },
         {
           id: 3,
           title: 'Otro tipo de documentos identificativos'
         },
       ],
       tj: 'Submáscara',
       shz: 'En revisión',
       shtg: 'Aprobado'
    },
    gjrz:{
      title:'Certificación senior',
      zj_info:['1. Se admiten imágenes de menos de 8MB y en formato JPG JPEG o PNG.','2. Las fotos del documento de identidad deben ser claras y no deben ser modificadas ni bloqueadas. El número del documento fotográfico personal y el nombre del titular del documento deben ser claramente visibles.','3. Las fotos deben tomarse sin ningún tipo de tocado y se recomienda no incluir el uso de maquillaje. Los rasgos faciales de la foto deben ser claros y reconocibles y sus brazos deben estar completamente expuestos.'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'Configuraciones de seguridad',
      bind:[{bind_title:'Restablecer contraseña',bind_name:'Correo electrónico'},{bind_title:'Establezca la contraseña de retirada',bind_name:'Correo electrónico'}]
    },
    wdtg:{
      own_code:'Código de invitación',
      own_code_url:'Invitar a conectarse',
      own_push_title:'',
      own_push_content:['','',''],
      own_push_content_profit:['','','',''],
      own_push_content_num:['','','',''],
      own_push_profit_title: ['ID', 'ingresos', 'Marque','agregar tiempo'],
      own_push_num_title: ['ID', 'nombre', 'Teléfono','agregar tiempo'],
    },
    jyzt_td: ['hora', 'Detalles', 'Monto'],
    cbjl_td: ['hora', 'Moneda', 'Importe','estado'],
    sfrz_txt: ['KYC', 'Ha enviado la revisión, espere el resultado', 'Has superado la Certificateación senior', 'Subir foto del anverso del documento de identidad', 'Subir foto del reverso del documento de identidad', 'verificación','Error de autenticación, vuelva a autenticarse'],

    zhsz_txt: ['El nivel de seguridad de su cuenta: #', 'El nivel de seguridad de su cuenta: #，Mejorar más información para garantizar la seguridad de la cuenta'],
    zhsz_m: 'Fuerte',
    zhsz_n: 'débil',
    zhsz_p: 'No es seguro',
    zhsz_detailList: [
      { icon: '/static/image/User_Center-password.png', title: 'Contraseña de acceso ', value: 'Las cuentas de Internet corren el riesgo de ser robadas. Se recomienda que cambie su contraseña con regularidad para proteger la seguridad de su cuenta.',value2:'', btn: 'Modificación',bind_email:'Enlaza primero tu correo electrónico o teléfono móvil', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: 'Contraseña de transacción', value: 'configurar la clave', btn: 'Configurar', path: '/bindmpwd' }
    ],
    sksz_txt: ['Configuración de la colección', 'Guardar'],
    sksz_list: [
      { label: "nombre de usuario:", pl: "Por favor ingrese el nombre de usuario", key: "name" },
      { label: "Nombre de la cuenta bancaria:", pl: "Por favor, introduzca el nombre de la cuenta bancaria", key: "bank_name" },
      { label: "Cuenta bancaria:", pl: "Por favor, introduzca el número de cuenta", key: "bank_number" },
      { label: ":", pl: "", key: "alipay_account" },
      { label: "", pl: "", key: "weixin_nickname" },
      { label: "", pl: "", key: "weixin_account" }
    ]
  },
  pasination: {
    first: 'Inicio',
    prev: 'Pagina anterior',
    next: 'Siguiente página',
    last: 'última página',
    no_data: 'Sin datos',
  },
  asset: {
    title: 'Mis activos',
    zjhz: 'Transferencia de fondos',
    cb: 'Depósito',
    gz: 'Valoración del USDT',
    atnv: [],
    zh_title: 'Activos totales convertidos：',
    index_title: 'activos',
    address_title: 'Moneda',
    address_txt: ['por favor elige', 'Dirección de retirada de fondos', 'Por favor ingrese contenido', 'Marque', 'Lista de direcciones'],
    address_btn: ['añadir', 'Guardar', 'Borrar', 'Editar'],
    address_td: ['Moneda', 'Dirección de retirada de fondos', 'Marque', 'operando'],
    currency_td: ['Moneda', 'Disponible', 'Congelar', 'Cantidad convertida'],

    table_title: 'Los activos totales：',
    table_address_title: 'Dirección de retirada de fondos',
    table_td: ['Moneda', 'Disponible', 'Congelar', 'Cantidad convertida', 'operando'],
    table_btn: ['Depósito', 'Retirada de fondos', 'Registro', 'Transferir'],

    money_text: ['Dirección de retirada de fondos', 'por favor elige', 'Importe', 'Disponible：', 'Tarifa',
      'Importe a retirar', 'Contraseña de transacción','etiqueta(Memo)','Mínimo'],
    money_btn: 'Retirada de fondos',
    xzbz: 'Selección de moneda',
    money_msg: ['recordatorio ',' ', '','','',''],

    recharge_title: 'Dirección de depósito',
    recharge_btn: ['Copiar', 'Código QR', 'Depósito'],
    recharge_text: ['Importe', 'recordatorio', 'Por favor, no ingrese ningún activo que no sea en moneda local en la dirección mencionada o los activos no se recuperarán', 'Los depósitos del USDT solo admiten el método de envío simple. Los depósitos que utilicen otros métodos (enviar todos) no se pueden contabilizar temporalmente. Por favor, comprenda.', 'certificado', 'Descripción del bono(Opcional)','Nombre de la cadena'],

    record_title: 'Registros financieros',
    record_td: ['Importe', 'Registro', 'Hora'],

    transfer_title: 'Transferir',
    transfer_btn: ['Todos', 'Transferir'],
    transfer_text: ['de', 'a', 'Ingrese el monto de la transferencia', 'Disponible：'],
    "bq": "Etiqueta (Memo)",
    "qsrbq": "Por favor, introduzca la etiqueta",
    "yhktx": "Retiro con tarjeta bancaria",
    "yhmc": "Nombre del banco",
    "qsryhmc": "Por favor, introduzca el nombre del banco",
    "yhzh": "Cuenta bancaria",
    "qsryhzh": "Por favor, introduzca la cuenta bancaria",
    "gjhkdm": "Código SWIFT",
    "qsrgjhkdm": "Introduzca el código SWIFT",
    "yhdz": "Dirección del banco",
    "qsryhdz": "Ingrese la dirección del banco",
    "skrxm": "Nombre del beneficiario",
    "qsrskrxm": "Ingrese el nombre del beneficiario",
    "skrdh": "Teléfono del beneficiario",
    "qsrskrdh": "Por favor, introduzca el teléfono del beneficiario",
    "skrdz": "Dirección del beneficiario",
    "qsrskrdz": "Por favor, introduzca la dirección del beneficiario"
  },
  text: {
    btn: 'espalda',
    login: 'Por favor, registrese'
  },
  deal: {
    chooseType: 'Tipo de comisión',
    choose: 'por favor elige',
    balance: 'Saldo：',
    account: ['Cuenta', 'Disponible', '/Congelar', 'Transferir'],
    dir: ['Comprar', 'Vender'],
    dir2: ['Disponible', 'Mercado'],
    cs: 'Favoritos',
    sxf: 'Tipo de comisión',
    jye: 'transacciones',
    sc_list: ['Precio de mercado', 'par', 'Incrementar'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt: ['Moneda', 'Último precio', 'Incrementar'],
    k_line_txt: ['≈', '', 'Incrementar', 'Precio más alto', 'El precio más bajo', 'Volumen 24H'],
    tabListLTitle: ["Orden actual", "Historial de ordenes "],
    tabListLEntrust: ["Comprar", "Vender"],
    tabListRTitle: ["Límite de precio", "Precio de mercado"],
    table_btn: ['Retirar fondos'],
    index_td_l: ['Hora', 'Socios comerciales', 'Importe', 'Precio', 'operando'],
    index_td_r: ['Último precio', 'Dirección', 'Precio', 'Importe'],
    index_td_r2: ['Última transacción', 'Hora', 'Precio', 'Volumen de comercio'],
    table_txt: ['terminado', 'Retirado'],

    db_1_txt: ['Disponible', 'precio de compra', 'Precio de venta', 'Aceptacion', 'Vender volumen', 'Venta', 'Compra al mejor precio del mercado', 'Vende al mejor precio del mercado', 'Comprar lote', 'Vender lote'],
    db_2_txt: ['Precio', 'Aprovechar', 'por favor elige', 'Lotes de negociación', 'Lote =', 'lotes', 'Valor de mercado del contrato', 'Bono', 'Compra al mejor precio del mercado', 'Vende al mejor precio del mercado'],
    pathList: ['Registro de contrato', 'Registro de la transacción'],
    db_btn: ['Comprar(Largo)', 'Vender(Corto)'],
    tabListLTitle2: ['Orden actual'],

    lt_btn: ['Liquidar con un clic', 'Obtenga ganancias y deje de perder', 'Cerrar posición', 'Submáscara', 'espalda'],
    lt_txt: ['Tasa de riesgo：', 'Beneficio total：'],
    lt_td: ['Tipos de','Aprovechar', 'Precio de la posición', 'Precio actual', 'Bono', 'Precio de toma de beneficios', 'Precio stop-loss', 'Hora de apertura', 'Lotes de negociación', 'Ganancia y perdida', 'operando'],
    lt_dl: ['Obtenga ganancias y deje de perder', 'Precio de toma de beneficios', 'Precio stop-loss'],

    lt_0_btn: ['Retirar fondos'],
    lt_0_td: ['Detalles de contacto', 'Moneda', 'Importe', 'Precio actual', 'Tarifa', 'operando'],

    lt_1_btn: ['Cerrar posición'],
    lt_1_txt: ['Cerrando posición'],
    lt_1_td: ['Tipos de', 'Precio de la posición', 'Precio actual', 'Bono', 'Precio de toma de beneficios', 'Precio stop-loss', 'Hora de apertura', 'Tarifa', 'Ganancia y perdida', 'operando'],
    node_data: 'Sin datos',

    lt_3_txt: ['Posición cerrada', 'Liquidación'],
    lt_3_td: ['Tipos de', 'Lotes de negociación', 'Precio de la posición', 'Precio de cierre', 'Precio de toma de beneficios', 'Precio stop-loss', 'Bono', 'Margen disponible', 'Hora de apertura', 'Hora de cierre', 'Tarifa',
      'Ganancia y perdida', 'operando'],

    lt_4_txt: ['Retirado'],
    cm: ['Hora de salida', 'Número de edición', 'Circulación total', 'Precio total', 'Sitio web oficial','Papel blanco','Información'],
    qsrsl: 'Introducir el importe',
    qsrss: 'Entrar en Lotes de Negociación',
  },
  notice:{
      notice_title:'Centro de anuncios',
  },
  bzhl:{
    title: 'AI Ganar monedas',
    title1: 'Cuantificación de IA',
    ttzbt: 'Sigue ganando dinero todos los días',
    wdtg: 'Pedir deposito en garantía ',
    zztgdzj: 'Fondos en custodia',
    yjjrsy: 'Ingresos del día',
    ljsy: 'Ingresos acumulados',
    tgzdd: 'Pedido en custodia',
    tgdd: 'Pedido en custodia',
    t1: 'Gestión financiera estable y de bajo riesgo, reembolsable en cualquier momento si es necesario',
    t2: 'Su asistente de administración de dinero gratuito',
    cljxcp: 'Ciclo del producto',
    dbxe: 'Límite único',
    rsyl: 'Tasa de rendimiento diaria(%)',
    rsyl2: 'Tasa de rendimiento diaria：',
    zq: 'Ciclo',
    qmr: 'Comprar',
    ckgd: 'más',
    cpgk: 'Descripción del producto',
    pxsj: 'Tiempo de dividendo',
    tgzj: 'Capital en custodia',
    tqsh: 'Retorno anticipado',
    cpld: 'Destacados del producto',
    cpgz: 'regla',
    cont: 'La ganancia de USDT es administrada por el equipo profesional de la plataforma alojando USDT en la plataforma. Los participantes pueden obtener la participación en los ingresos de la plataforma durante el período de custodia del fondo, al que se puede acceder en cualquier momento, lo cual es seguro y conveniente.',
    zj: '100%fondos',
    aqbz: 'Seguridad',
    jjrsy: 'Ingresos de vacaciones',
    bjd: 'Ininterrumpido',
    cgcrh: 'Después de un depósito exitoso',
    dtqx: 'Calcule el interés del día',
    ljzr: 'Transfiera ahora',
    xqglgj: 'Herramientas gratuitas de administración de dinero',
    ddh: 'Número de pedido',
    tgje: 'Importe de la custodia',
    tgsj: 'tiempo de la custodia',
    yhl: 'Beneficios obtenidos/días restantes',
    xdsj: 'Tiempo de pedido',
    zt: 'estado',
    fh: 'espalda',
    qrnhsy: 'Ingreso anualizado de siete días',
    ygy: '1 mes',
    bn: 'Medio año',
    yn: '1 año',
    yuan: '$',
    tzfx: 'riesgo de inversión',
    shsc: 'Tiempo de redención',
    di: 'bajo',
    yggzr: 'Un día laborable',
    msgsxf: 'Cuota de suscripción gratuita',
    mr: 'Diario',
    dqfh: 'Retorno a vencimiento',
    ljgm: 'Comprar ahora',
    tgz: 'Pedido en custodia',
    sh: 'Retorno anticipado',
    ywc: 'terminado',
    ysh: 'Recuperar',
    all: 'Todos',
    "xzbzts": "Sencillo y seguro. Los dividendos se pueden seleccionar en varias monedas",
    "qtbz": "Otras monedas"
  },
  pay:{
    qsrjymm: 'Longitud de la contraseña 6 dígitos',
    tbmmts: 'Vaya al centro de usuarios para configurar la contraseña de la transacción',
  },
  tips:{
    qxztbdz: 'Por favor, introduzca la dirección de retiro',
    qsrtbsl: 'Introducir el importe'
  },
  statusText: ['falla','Procesando','éxito'],
  dzrz: {
    title: 'Autenticación de dirección',
    sdddz: 'Dirección de la factura de servicios públicos',
    zdtpsc: 'Carga de imagen de factura',
    qsrsdddz: 'Debe completar la información de la dirección y enviar la factura de servicios públicos o la factura de dirección de banda ancha',
    qsczdtp: 'Sube una foto de la factura',
    status: ['En revisión','Aprobado'],
    qd: 'ACEPTAR',
  },
  jgcc: {
    wtgd: 'Orden pendiente',
    cj: 'Transacción',
    jj: 'Información',
    zc: 'Actualidad',
    lszc: 'Historia',
    qblx: 'Todos los tipos',
    xj: 'Precio actual',
    sj: 'Hora',
    fx: 'Dirección',
    jg: 'Precio',
    sl: 'Importe',
    jgsj: 'Hora de entrega',
    gmj: 'Precio de compra',
    jsj: 'Precio de liquidación',
    yk: 'Ganancia y perdida',
    xq: 'Detalles',
    "mz": "Alcista",
    "md": "Osuno",
    dqye: 'Saldo actual',
    gb: 'Cerrar',
    jxxd: 'Continuar con el pedido',
    qrxd: 'Confirmar',
    ddqr: 'Confirmación de pedido',
    sxf: 'Tarifa',
    kyye: 'Equilibrio',
    jypz: 'Par',
    jyfx: 'Dirección',
    tzje: 'Monto de inversión',
    tzjeTips: 'Precio más bajo 0',
    dqsj: 'Hora de caducidad',
    jssj: 'Hora de entrega',
    gmsj: 'Tiempo de compra',
    sy: 'ingresos',
    zxje: 'Monto minimo ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje: 'Cantidad máxima ',
    qsrje: 'Ingrese el importe',
    zxtzje: 'Mínimo ',
    yebz: 'Saldo insuficiente',
    xq: 'Detalles',
    ddz: 'Esperando',
    jgjl: 'Registro de entrega',
    bz: 'Moneda',
    cz: 'operando'
  },
  kjmb: {
    title: 'Comprar criptografía',
    fzcg: 'Copiar con éxito',
    ljmb: 'Comprar criptografía',
    lxkf: 'Contactar Servicio al Cliente'
  },
  news: {
    title: 'Mis mensajes',
    "gg": "Notificación",
    ckxq: 'Ver detalles',
  },
  statusTabs:['Orden pendiente', 'En transacción','Posición cerrada', 'Retirado'],
  "chongzhi":{
    "zy": "Importante",
    "cbxx": "Información de depósito de tokens",
    "qsrsl": "Ingrese el monto del depósito",
    "tips2": "1. Compatibilidad de billetera / plataforma: es decir, la red es compatible, si la plataforma de destino no es compatible con su red de retiro, los activos no se pueden recuperar.",
    "tips3": "2. Su red de recarga y la plataforma de destino son la misma, si elige la dirección de destino es la red Ethereum, pero la recarga elige la cadena inteligente TRC20, es posible que no pueda recuperar sus activos digitales.",
    "tips4": "3. Asegúrese de que su dirección y la cantidad sean correctas antes de recargar.",
    "tips5": "Recordatorio: debido al anonimato y la privacidad de la red de bloques, una vez que ingrese la información incorrecta, perderá los activos correspondientes. Comprueba cuidadosamente tu dirección de recarga y la cantidad.",
    "tips2_1": "• No cargue ningún activo en moneda que no sea local a la dirección anterior, de lo contrario, los activos no se podrán recuperar.",
    "tips2_2": "• La moneda digital no se puede entregar a tiempo. La hora de llegada real depende de la velocidad de confirmación de la cadena de bloques.",
    "tips2_3": "• Su dirección de recarga no cambiará con frecuencia, puede recargar; si hay algún cambio, haremos todo lo posible para notificarle a través de un anuncio en el sitio web o por correo electrónico.",
  },
  "tibi": {
    "tbxx": "Información de retiro",
    "qsrbq": "Introduzca una etiqueta",
    "tbTips1": "• Para garantizar la seguridad de los fondos, cuando la política de seguridad de su cuenta cambie, la contraseña cambie, revisaremos manualmente el retiro, espere pacientemente a que el personal se comunique con usted por teléfono o correo electrónico.",
    "tbTips2": "• Asegúrese de que su computadora y navegador sean seguros para evitar que la información sea alterada o filtrada.",
    "tbTips3": "• El activo digital que mencionaste es un activo multicadena de una moneda. Independientemente de la cadena desde la que elijas subir, significa que la cantidad total de activos digitales que se muestran en la página de retiro de tu propiedad se reducirá por la cantidad correspondiente recaudada. ",
  },
  "gjlb": "Lista de países",
  "qxzgjlb": "Por favor seleccione País / Región",
  "mbwt":{
    "title": "Cuestiones de seguridad",
    "mbwt": "Cuestiones de seguridad",
    "problem":[
      {
        "id": 1,
        "title": "Quién es tu mejor amigo(amiga)"
      },
      {
        "id": 2,
        "title": "Quien es tu idolo"
      },
      {
        "id": 3,
        "title": "Dónde está tu lugar más anhelado"
      }
    ],
    "qtxda": "Por favor, responda a la pregunta",
    "qsrxmm": "Ingrese una nueva contraseña",
    "qqrmm": "Por favor, confirme su contraseña",
    "sydqmmcz": "Restablecer con la contraseña actual",
    "zhmm": "Problemas de seguridad Recuperar contraseña",
    "ysz": "Configurar",
    "tg": "Ignorar",
    "tj": "Enviar",
    "zyts": "Importante:",
    "zytsCont": "No revele la respuesta secreta y el código de verificación, y tenga en cuenta el problema de seguridad, que lo ayudará a recuperar su contraseña."
  },
  "zc":{
    "zclb": "Lista de activos",
    "zczh": "Conversión de activos",
    "yczc": "Ocultar activos que no tiene"
  },
  "indexNew":{
    "t1": "Líder mundial",
    "t2": "Plataforma de servicios de activos digitales",
    "t3": "Transacción completa de activos digitales blockchain de ventanilla única",
    "t4": "Número de móvil / correo electrónico",
    "t5": "Regístrese ahora",
    "t6": "Dar la bienvenida a clientes de todo el mundo a través de MFTG",
    "t7": "Descubra e inicie su viaje de cifrado"
  },
  "newReg":{
    "dl": ['Email','Móvil'],
    "cjzh": "Crear una cuenta",
    "sysjhzyx": "Número de móvil / registro de correo electrónico",
    "yhxy": "&lt;Acuerdo de usuario&gt;",
    "yhxy2": "He leído y acepto el &lt;Acuerdo de usuario&gt;",
    "yxgz": "Por favor introduzca una dirección de correo electrónico válida",
    "dhgz": "El número de teléfono móvil es incorrecto."
  },
  "indexNew2": {
    "t1": "Opere en nuestro pedido",
    "t2": "Usar Bitbank",
    "t3": "Bitbank es un intercambio ingeniosamente diseñado de bitcoins y activos cifrados. Es muy simple, conveniente, seguro y poderoso. Admite transacciones en múltiples plataformas web y de teléfonos inteligentes. Los datos y gráficos de las transacciones se actualizan en tiempo real. Completo El análisis de precios de mercado proporciona más de 60 herramientas de análisis técnico. Empiece a operar ",
    "ksjy": "Empiece a operar",
    "ly": "5 razones para elegir Bitbank",
    "item1_t1": "Volumen de operaciones líder",
    "item1_t2": "N ° 1 * Volumen de negociación de activos criptográficos",
    "item1_t3": "Negociación cómoda (experiencia comercial agradable) con alta liquidez. Enumere 12 tipos de activos criptográficos.",
    "item2_t1": "Evaluación de terceros alta",
    "item2_t2": "Entorno comercial seguro",
    "item2_t3": "Use la billetera fría sin conexión. Use Multisig para mantener alejados a los piratas informáticos. Proteja sus activos con alta tecnología",
    "item3_t1": "Aplicación confiable y fácil de usar",
    "item3_t2": "Fácil de usar y aplicación sencilla",
    "item3_t3": "Una aplicación confiable con funciones ricas. Puede mantener oportunidades comerciales fuera de la transacción.",
    "item4_t1": "Abierto todo el día",
    "item4_t2": "Puede depositar oro",
    "item4_t3": "Soporte de depósito las 24 horas, incluidos festivos",
    "item5_t1": "Smartphone y PC",
    "item5_t2": "Diseño humanizado",
    "item5_t3": "Incluso si usa un teléfono inteligente, puede realizar transacciones simples y calificadas sin dudarlo",
    "aqkk": "Seguro y confiable",
    "aqkk2": "Transacción Bitcoin de Bitbank",
    "cjzh": "Crear una cuenta",
  },
  "xbsg":{
    "title": "Nueva zona de monedas",
    "wdsg": "Detalles",
    "scts": "Días de encierro: ",
    "sy": "restante",
    "ljsg": "Suscríbase ahora",
    "ysk": "Vendido",
    "xzjdy": "Suscríbase ahora",
    "dy": "Suscribir",
    "fxjg": "precio de emisión",
    "fxl": "Circulación",
    "ssrq": "Fecha de cotización",
    "yxqx": "Período de validez",
    "qsrsl": "Por favor ingrese la cantidad",
    "syl": "restante",
    "sgrq": "suscribir",
    "sgsl": "Monto",
    "bz": "Moneda",
    "yebz": "Saldo de USDT insuficiente",
    "tgsl": "Cantidad de pases",
    "shz": "bajo revisión",
    "wtg": "No pasó",
    "ytg": "aprobado"
  },
  "wydb":{
    "title": "Pedir prestado",
    "db": "Pedir prestado",
    "dbz": "Pedir prestado",
    "jl": "registro",
    "jdzq": "Período (días)",
    "qhk": "Volver a pagar",
    "ljdb": "Acumulativo (usdt)",
    "dhkbs" :"pago pendiente",
    "jkje": "cantidad (usdt)",
    "qsrje": "Por favor ingrese la cantidad",
    "rll": "Tasa de interés diaria",
    "hkfs": "Reembolso",
    "dqych": "Caducado",
    "lx": "Interesar",
    "fkjg": "Prestador",
    "tpsc": "Préstamo de crédito (carga de imagen)",
    "fwxx": "Información de vivienda",
    "srzm": "Comprobante de ingresos (relación laboral)",
    "yhmx": "Extracto de cuenta",
    "zjz": "foto de identificación",
    "yd": "He leído y estoy de acuerdo",
    "xy": "Solicitar un acuerdo de préstamo",
    "sqdb": "solicitar cadenas de préstamo",
    "gb": "cierre",
    "qd": "OK",
    "ts": "Por favor marque Solicitar un acuerdo de préstamo",
    "dbjl": "registro",
    "hkhth": "Código de orden",
    "wsh": "sin revisar",
    "yfk": "Préstamo",
    "sqrq": "tiempo de aplicación",
    "zq": "ciclo",
    "dbsl": "Monto",
    "zhke": "Pago total",
    "yhkxq": "Detalles de reembolso",
    "bqyhk": "Reembolsable en el período actual(USDT)",
    "hktips": "Asegúrese de que el saldo sea suficiente, si el saldo es insuficiente, recargue primero y luego pague",
    "bj": "Principal",
    "jie": "Pedir prestado",
    "ljhk": "pagar inmediatamente",
    "qcz": "Depositar",
    "yebzqxcz": "Saldo insuficiente, recargue primero y luego pague",
    "znj": "cargo del pago atrasado",
    "yqts": "Dias atrasados"
  },
  "hkxq":{
    "dd":"Pedido",
    "fzhkdz":"Copia la dirección de pago",
    "hkxq": "Detalles de reembolso",
    "zlx": "interés total",
    "zhk": "reembolsos totales",
    "hkjg": "agencia de pago",
    "qschkpz": "Cargue el certificado de reembolso",
    "hkpz": "certificado de reembolso"
  },
  "bbjyNew":{
    "jylx": "Tipos de",
    "jyze": "Cantidad"
  },
  "bind":{
    "title": "Verificacion de Email",
    "ybd": "Unido",
    "wbd": "Sin consolidar",
    "ts": "Para proteger su cuenta, se recomienda vincular una dirección de correo electrónico",
    "qsryxdz": "Por favor, introduzca su dirección de correo electrónico"
  },
  "tipsNew": {
    "yjj": "rechazado",
    "shz": "redención"
  },
  "newIndex2":{
    "zxhy": "Cotizaciones más recientes",
    "jypt": "Plataforma comercial",
    "ssyc": "Reducir Ocultar",
    "hwzc": "Aún no estás registrado",
    "ljzc": "¡Regístrate ahora y descubre toneladas de oportunidades!",
    "yyzh": "Ya tienes una cuenta",
    "hjbj": "Inicia sesión si tienes una cuenta, ¡mucho tiempo sin verte!",
    "lmdh": "Navegación por columnas",
    "ghdjy": "Mejor trato, mejor vida",
    "ghdjy02": "El centro de intercambio de criptomonedas más innovador del mundo está aquí, donde puedes comprar, intercambiar y ganar criptomonedas con cientos de criptomonedas al alcance de tu mano.",
    "indexCont01": "Siempre a tu lado",
    "indexCont02": "Opere en nuestros mercados al contado y de margen con opciones de financiación avanzadas, ejecución ultrarrápida y gran liquidez.",
    "indexCont03": "Potente API",
    "indexCont04": "Gestione sus posiciones sin esfuerzo con nuestra API intuitiva, nuestra plataforma de operaciones y opciones de órdenes avanzadas.",
    "indexCont05": "Activos digitales de alta calidad",
    "indexCont06": "9 años 0 accidentes",
    "indexCont07": "Control de riesgos de seguridad superior",
    "indexCont08": "Apalancamiento hasta 25 veces",
    "indexCont09": "Opere con CFD de Bitcoin con un apalancamiento de hasta 25x.",
    "indexCont010": "Reserva de seguridad",
    "indexCont011": "Liquidez Profunda",
    "indexCont012": "Nuestra avanzada tecnología patentada de libro de pedidos de múltiples mercados mejora la liquidez, ajusta los diferenciales y reduce el deslizamiento.",
    "indexCont013": "Preferencia del usuario",
    "indexCont014": "País cubierto",
    "indexCont015": "Nuestras fortalezas",
    "indexCont016": "Opere en nuestros mercados al contado y de margen con opciones de financiación avanzadas, ejecución ultrarrápida y gran liquidez.",
    "indexCont017": "Almacenamiento Seguro",
    "indexCont018": "Usamos una combinación de billeteras frías y tecnología de computación multipartita (MPC) para administrar los activos digitales.",
    "indexCont019": "La seguridad ante todo",
    "indexCont020": "Usamos la última tecnología para mantener sus fondos seguros y anticiparnos a errores e intentos de explotación.",
    "indexCont021": "Retiro rápido",
    "indexCont022": "Usando el cómputo de múltiples partes, podemos proporcionar retiros rápidos las 24 horas del día, los 7 días de la semana, manteniendo nuestros estrictos estándares de seguridad.",
    "indexCont023": "Comprar, vender criptomonedas",
    "indexCont024": "Únase a la plataforma comercial más completa y segura del mundo",
    "indexCont025": "Compra y vende Bitcoin, Ethereum, XRP y muchas otras criptomonedas usando fiat o criptomonedas.",
    "yqwj": "10 millones+",
    "dlzc": "Iniciar sesión para registrarse",
    "yzm": "Código de verificación",
    "qrmm": "Confirmar contraseña"
  },
  "langNew2":{
    "flzq": "Centro de recompensas",
    "qdjl": "Iniciar sesión recompensa",
    "mrqdjl": "Recompensa de inicio de sesión diario",
    "qd": "Iniciar sesión",
    "yqd": "Registrado",
    "hdgz": "Reglas del evento",
    "qdjl2": "registro de entrada",
    "qdcg": "Iniciar sesión con éxito",
    "yhd": "Adquirido",
    "lq": "Recibir",
    "dyt": "Día 1",
    "det": "Día 2",
    "dst": "Día 3",
    "dsit": "Día 4",
    "dwt": "Día 5",
    "dlt": "Día 6",
    "dqt": "Día 7",
    "jxz": "en progreso",
    "cjxnzh": "Crear una cuenta demo",
    "sy":"Pagina de inicio",
    "sc":"Mercado",
    "sclb":"Lista de mercado",
    "jy":"Comercio",
    "zh":"Cuenta",
    "db":"Préstamos",
    "zchm":"Número de registro",
    "cp":"Producto",
    "tzjd":"Préstamos de inversión",
    "zxzc":"Soporte en línea",
    "xd":"Orden",
    "zzjptgmnr":"Invierta en su futuro. Haga crecer su cartera en un sistema financiero justo y abierto.",
    "yy":"Aplicación",
    "pqnr":"Banca móvil que rompe con las reglas tradicionales y te proporciona herramientas precisas de gestión financiera.",
    "jiami":"Cripto",
    "tgnr":"Al realizar depósitos utilizando criptomonedas, obtienes una capa adicional de seguridad y garantizas un procesamiento rápido de las transacciones.",
    "jyl":"Volumen de operaciones las 24 horas",
    "ssjmhb":"Listado de criptomonedas",
    "zchy":"Usuarios Registrados",
    "djxz":"Haga clic para descargar",
    "azsc":"Mercado de Android",
    "pgsd":"Tienda Apple",
    "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
  },
  // "langNew":{
  //   "szhb": "Criptomoneda",
  //   "gjs": "Metal",
  //   "yy": "Crudo",
  //   "jy": "Comercio",
  //   "jmhb": "Criptomoneda",
  //   "yxhy": "Contrato perpetuo",
  //   "gdjy": "orden pendiente",
  //   "khh": "Abrir cuenta bancaria",
  //   "qsrkhh": "Por favor ingrese al banco",
  //   "yhkh": "Cuenta bancaria",
  //   "qsryhkh": "Por favor, introduzca el número de cuenta bancaria",
  //  },
   "login":{
     login: 'Ingresa, por favor',
     msg: 'Ingrese su cuenta registrada',
     list: ['móvil / correo electrónico', 'Contraseña', 'Ha olvidado su contraseña', 'iniciar sesión', 'Sin cuenta, regístrese ahora'],
     message: 'La cuenta o la contraseña no pueden estar vacías',
     "cdlks":"¡Comencemos con iniciar sesión!",
     "zh":"Cuenta",
     "qsrzh":"Ingrese su nombre de usuario",
     "mm":"Contraseña",
     "qsrmm":"Introducir la contraseña",
     "dl":"Iniciar sesión",
     "wjmm":"Has olvidado tu contraseña",
     "qbdl":"Iniciar sesión por billetera",
     "myzh":"No tengo una cuenta",
     "zc":"Inscribirse",
     "yzm":"Código de verificación",
     "qsryzm":"Ingrese el código de verificación",
     "hqyzm":"Código enviado",
     "qrmm":"confirmar Contraseña",
     "qsrqrmm":"confirmar Contraseña",
     "lcmmbyz":"Las dos entradas de contraseña son inconsistentes",
     "mmts":"Longitud de la contraseña de 6 a 12 caracteres",
     "sjtx":"Error de formato del número de teléfono",
     "yxts":"Error de formato de correo electrónico",
     "qr":"DE ACUERDO",
     "sjzc":"Móvil",
     "sjh":"Número de teléfono",
     "qsrsjh":"Ingresa número telefónico",
     "yqm":"Código de invitación (opcional)",
     "qsryqm":"Introduce el código de invitación",
     "yxzc":"Correo electrónico",
     "wyydbzx":"Aceptar",
     "yhxy":"<Acuerdo de servicios de usuario>",
     "yhxy2":"Acuerdo de servicios de usuario",
     "ysyx":"<Acuerdo de protección de privacidad>",
     "yx":"Correo electrónico",
     "qsryx":"Ingrese correo electrónico",
     "yxgsbzc":"Email inválido",
     "cjmnzhcg":"Cuenta demo creada exitosamente",
     "tcmnzh":"Salir de la cuenta demo",
     "qbdlts":"Utilice la billetera DAPP Iniciar sesión",
   },
  //  "index":{
  //    "xgnysx":"¡Nuevas funciones están en línea!",
  //    "hyld":"Bienvenido a nuestra galardonada plataforma de comercio financiero y explore el futuro mundo financiero con inversores globales",
  //    "symncz":"Utilice una cuenta demo",
  //    "zdjyfy":"Tarifas de transacción mínimas <0,3%",
  //    "jysyzc":"Opere con todos sus activos en un solo lugar",
  //    "hbsp":"Forex, Criptomonedas, Acciones, Índices, Materias Primas",
  //    "ksjy":"Comenzar",
  //    "jdewd":"Sencillo y estable",
  //    "aizb":"Comercio de IA dorado",
  //    "srjh":"Crea tu plan de ingresos en un clic",
  //    "kssy":"Empieza a usar",
  //    "dlyhggdje":"Tasas de interés bajas y cantidades más altas",
  //    "jmhbdk":"Préstamos en criptomonedas",
  //    "zmyrhdyp":"Tomar prestado un lugar de criptomonedas sin ninguna garantía",
  //    "gs":"Compañía",
  //    "gywm":"Sobre nosotros",
  //    "xkzjd":"Supervisión de licencia",
  //    "bzzx":"Centro de ayuda",
  //    "zhengce":"Política",
  //    "tkytj":"Términos condiciones",
  //    "yszc":"política de privacidad",
  //    "sm":"Declaración",
  //    "flxx":"Información legal",
  //    "mzsm":"Descargo de responsabilidad",
  //    "fxjg":"Advertencia de riesgo",
  //    "gygg":"Acerca de la publicidad",
  //    "gg":"Anuncio",
  //  },
   "hq":{
     "wh":"Forex",
     "szhb":"Cripto",
     "gp":"Existencias",
     "zs":"Índice",
     "eft":"ETF",
     "mc":"Nombre",
     "xs":"24h%",
     "tb":"Cuadro",
     "jg":"Precio",
   },
   "user":{
     "wdzh":"Mi cuenta",
     "zh":"Cuenta: ",
     "dk":"Préstamo: ",
     "sydbzj":"Margen utilizado: ",
     "yqll":"Ganancia esperada: ",
     "qtgn":"Otras funciones",
     "cz":"Depósito",
     "tx":"Retirar",
     "dh":"Intercambio",
     "zhyz":"Certificación KYC",
     "zhjl":"Registros de cuentas",
     "yqhy":"invitar amigos",
     "flzq":"Zona de bienestar",
     "ggmm":"Cambiar la contraseña",
     "sz":"Ajustes",
     "cjwtjd":"Preguntas más frecuentes",
     "fzdz":"Copiar dirección",
     "sl":"Cantidad...",
     "qsrsl":"Introduce la cantidad",
     "dd":"Obtener (USDT): ",
     "sczm":"Subir bono",
     "qsczm":"Por favor cargue el comprobante",
     "tj":"Entregar",
     "czjl":"Registro de depósito",
     "ddh":"No.",
     "wsh":"No revisado",
     "ywc":"Terminado",
     "bz":"Nombre: ",
     "sl2":"Cantidad: ",
     "sj":"Tiempo: ",
     "srsl":"Introduce la cantidad...",
     "dd2":"Conseguir: ",
     "qskgzflhd":"Por favor, preste siempre atención a las actividades de bienestar, las publicaremos de vez en cuando.",
     "hdlb":"Lista de eventos",
     "ckxq":"Ver detalles",
     "wdjl":"Mi recompensa",
     "yiji":"Nivel 1",
     "erji":"Nivel 2",
     "sanji":"Nivel 3",
     "je":"Cantidad",
     "sj2":"Tiempo",
     "yyxz":"Idioma",
     "tcdl":"desconectar",
     "je2":"Monto (USD)...",
     "qsrje":"Introduce la cantidad",
     "jsdz":"Dirección de recepción...",
     "qsrjsdz":"Introduzca la dirección de recepción",
     "sjdz":"Llegada real: ",
     "sxf":"Tarifa: ",
     "txsm1":"Los retiros requieren una tarifa del 5%, que debe ser confirmada por el nodo de la red antes de que se pueda acreditar.",
     "txsm2":"Por favor no transfiera criptomonedas a extraños",
     "tz":"Notificar",
     "wdyq":"Mi invitación",
     "yhid":"UID",
     "hdjl":"Obtenga recompensas en USD",
     "yqsm":"Invita a tus amigos a participar en la cuantificación de IA, alquilar máquinas de minería e intercambiar productos para obtener recompensas en criptomonedas.",
     "yqsy":"Ingresos por invitación",
     "yqrs":"Número de personas invitadas",
     "tgljyq":"Invitar a través de enlace",
     "lj":"Enlace",
     "yqm":"Código de invitación",
     "cbtb":"Depositar y retirar",
     "jymx":"Detalles de la transacción",
     "yqhyjl":"Recompensas por invitar amigos",
     "aidd":"Órdenes comerciales doradas de IA",
     "jdls":"Historial de préstamos",
     "etfdd":"Órdenes ETF",
     "jmhbdd":"Órdenes de criptomonedas",
     "whdd":"Órdenes de divisas",
     "gpdd":"Órdenes de stock",
     "qx":"Cancelar",
     "zc":"Activos",
     "zzc":"Los activos totales",
     "ky":"Disponible",
     "zh2":"Convertido (USDT)",
     "xzbz":"Seleccionar: ",
     "sztkts":"Importante: vaya al Centro de seguridad para establecer una contraseña de transacción",
     "jymm":"Clave de transacción",
     "szjymm":"Establecer contraseña de transacción",
     "qsrjymm":"Clave de transacción",
     "zdsl":"Cantidad mínima.",
     "bq":"Etiqueta (nota)",
     "qsrbq":"Introducir etiqueta",
     "yhktx":"transferencia bancaria",
     "yhmc":"Nombre del banco",
     "qsryhmc":"Introduzca el nombre del banco",
     "yhzh":"Cuenta bancaria",
     "qsryhzh":"Ingrese el número de cuenta bancaria",
     "gjhkdm":"Código SWIFT",
     "qsrgjhkdm":"Introduce el código SWIFT",
     "yhdz":"Dirección del banco",
     "qsryhdz":"Introduzca la dirección del banco",
     "skrxm":"Nombre del beneficiario",
     "qsrskrxm":"Introduzca el nombre del beneficiario",
     "skrdh":"Número de teléfono del beneficiario",
     "qsrskrdh":"Ingrese el número de teléfono del beneficiario",
     "skrdz":"Dirección del beneficiario",
     "qsrskrdz":"Introduzca la dirección del beneficiario",
     "tbjl":"registro de retiro",
     "fzcg":"Copiado exitosamente",
     "aqzx":"Centro de Seguridad",
     "yxrz":"Verificacion de Email",
     "ybd":"Atado",
     "wbd":"No unido",
     "yrz":"Verificado",
     "wrz":"No certificado",
     "ts":"Para proteger su cuenta, se recomienda vincular su dirección de correo electrónico",
     "qsryxdz":"Ingrese correo electrónico",
     "dlmm":"Contraseña de inicio de sesión",
     "mbwtsz":"Configuración de problemas de seguridad",
     "mbwt":"Problema de seguridad",
     "qtxda":"Por favor complete la respuesta",
     "zyts":"Importante: ",
     "zytsCont":"No revele la respuesta de seguridad ni el código de verificación, y recuerde la pregunta de seguridad, que le ayudará a recuperar su contraseña.",
     "qsrxmm":"Introduzca una nueva contraseña",
     "sydqmmcz":"Restablecer con contraseña actual",
     "zhmm":"Problema de seguridad para recuperar la contraseña",
     "ysz":"Ha sido establecido",
     "tg":"ignorar",
     "qsrdlmm":"Ingresa tu contraseña",
     "bzxz":"Seleccionar: ",
     "zwsj":"Sin datos",
     "qd":"DE ACUERDO",
     "zsgd":"Mostrar más",
     "zdss":"Tamaño mínimo del lote",
     "mnjy":"cuenta demo",
     "sx":"Selección",
   },
   "zb":{
     "tgdd":"Órdenes gestionadas por IA",
     "tgz":"En custodia",
     "ysh":"Redimido",
     "shz":"Redentor",
     "zq":"Ciclo: ",
     "tian":"Día",
     "syl2":"Tasa de retorno: ",
     "rgjg":"Precio de suscripción: ",
     "rgjg2":"Precio de suscripción",
     "xdsj":"Tiempo de la orden: ",
     "yhl":"Beneficiado: ",
     "syts":"El número restante de días: ",
     "sh":"Redención",
     "syl":"Tasa de retorno",
     "bz":"Nombre",
     "dl":"Tipo de cambio",
     "tgts":"Días de hospedaje: ",
     "tgsl":"Cantidad de alojamiento",
     "qsrtgsl":"Ingrese la cantidad de alojamiento",
     "dbxe":"Límite de transacción única",
     "ljtg":"Anfitrión ahora",
     "zztg":"Fondos en custodia",
     "yjjrsy":"Ganancias estimadas hoy",
     "ljsy":"Ingresos acumulados",
     "tgzdd":"Orden de custodia",
     "ljzc":"Transferir ahora",
     "gz":"Regla",
     "cpzq":"Ciclo del producto",
     "gm":"Comprar",
     "ts":"Importante",
     "shts":"Estás en el proceso de operación de canje y perderás el 5% si canjeas antes del vencimiento. ¿Estás seguro de canjear?",
     "xgcs":"Número de restricciones de compra",
   },
   "dk":{
     "dk":"Préstamo",
     "dkzh":"cuenta de préstamo",
     "yzsf":"¡Verifique su identidad y obtenga más montos de préstamos!",
     "ksyz":"Iniciar verificación",
     "wxj":"quiero pedir prestado...",
     "dkqx":"Plazo del préstamo (días): ",
     "mrll":"Tasa de interés diaria: ",
     "lxze":"Interés total: ",
     "dkts":"No se requieren intereses sobre el préstamo durante 3 días y los intereses se pueden pagar posteriormente",
     "xzj":"Préstamo ahora",
     "wyydbzx":"Aceptar",
     "dkfwxy":"<Acuerdo de servicio de préstamo>",
     "dkfwxy2":"Acuerdo de servicio de préstamo",
     "dkysxy":"Acuerdo de privacidad del préstamo",
     "dkjl":"Historial de préstamos",
     "hth":"No.",
     "yfk":"Desembolsado",
     "lx":"Interés: ",
     "zhke":"Importe total del reembolso: ",
     "znj":"Cargo del pago atrasado: ",
     "znjl":"Tasa de cargo por pago atrasado: ",
     "yqts":"Dias atrasados: ",
     "qhk":"Volver a pagar",
     "tpsc":"Préstamo de crédito (carga de imagen)",
     "fwxx":"Información de vivienda",
     "srzm":"Comprobante de ingresos (relación laboral)",
     "yhmx":"Detalles del banco",
     "zjz":"foto de identificación",
     "ljdk":"Préstamo ahora",
     "xm":"Nombre",
     "ndxm":"Su nombre",
     "qsrndxm":"Introduzca su nombre",
     "gj":"País",
     "ndgj":"Tu país",
     "qsrndgj":"Introduce tu país",
     "dz":"DIRECCIÓN",
     "nddz":"Su dirección",
     "qsrnddz":"Introduce tu dirección",
     "csrq":"Fecha de nacimiento",
     "ndcsrq":"Tu fecha de nacimiento",
     "qsrndcsrq":"Introduzca su fecha de nacimiento",
     "dhhm":"Número de teléfono",
     "nddhhm":"Su número de teléfono",
     "qsrnddhhm":"Ingrese su número telefónico",
     "zj":"Documentos",
     "sfzm":"Identidad positiva",
     "qscsfzm":"Sube el lado positivo de tu identidad",
     "sffm":"Contrario de identidad",
     "qscsffm":"Sube el reverso de tu identidad",
     "ddqr":"Confirmación del pedido",
     "jk":"Préstamo: ",
     "dkqx2":"Plazo del préstamo: ",
     "qrxd":"Confirmar pedido",
     "yhkxq":"Detalles del reembolso vencido",
     "hkqr":"Confirmación de pago",
     "yhk":"Deuda de Reembolso: ",
     "jksj":"Tiempo de préstamo: ",
     "ljhk":"Paga inmediatamente",
   },
   "jy":{
     "rq":"fecha",
     "qqjy":"Registro de opciones",
     "hyjy":"Contrato",
     "qqhy":"Opciones",
     "dqwt":"Pendiente",
     'wtz':"En Comisión",
     "hyjl":"Registro de contrato",
     "shou":"Lotes",
     "dk":"Oh: ",
     "zhjg":"El último: ",
     "jyfy":"Tarifa de transacción: ",
     "kfsj":"Horario de apertura: ",
     "gg":"Palanca: ",
     "pl":"Lote: ",
     "kpj":"Precio de apertura: ",
     "yk":"Ganancia y perdida: ",
     "cd":"Cancelar orden",
     "jsj":"Precio acordado: ",
     "fx":"Dirección: ",
     "jgsj":"El tiempo de entrega: ",
     "gb":"Cerca",
     "jxxd":"Continuar",
     "xj":"Límite: ",
     "gm":"Comprar: ",
     "sl":"Cantidad",
     "fy":"Costo: ",
     "tzbzj":"Ajustar margen",
     "zyzs":"Obtenga ganancias y detenga las pérdidas",
     "pc":"Posición cercana",
     "mr":"Comprar",
     "zjbzj":"Aumentar margen",
     "jsbzj":"Reducir margen",
     "yxhy":"comercio por contrato: ",
     "cc":"Puesto(s): ",
     "cc2":"Posición",
     "cwbzk":"Margen de posición: ",
     "zdzjbzj":"Incremento máximo de margen: ",
     "zjbzj2":"Aumentar margen: ",
     "qsrzbzj":"Por favor ingrese el depósito",
     "yxhy2":"Perpetuo",
     "kp":"puede ser plano",
     "zhang":"Abierto",
     "xj2":"Límite",
     "zy":"Saca provecho",
     "zs":"Detener la pérdida de",
     "ssjyzl":"Buscar tipo de transacción",
     "ddb":"Libro de pedidos",
     "di":"L: ",
     "gao":"h: ",
     "gb2":"C: ",
     "fz":"Minuto",
     "mai":"Compra: ",
     "zhang2":"Elevar",
     "tie":"Caer",
     "sy":"Devolver",
     "kz":"Alcista",
     "kt":"Osuno",
     "bndy":"No puede ser inferior a",
     "sxbzj":"Depósito de seguridad requerido: ",
     "ky":"Disponible: ",
     "sj":"Mercado",
     "mc":"Vender",
     "zxtzsl":"Cantidad mínima",
     "min":"Monto minimo",
     "max":"mayor cantidad",
     "yebz":"Saldo insuficiente",
     "ddz":"Espera",
     "wtzl":"Monto de comisiones: ",
     "wtjg":"Precio de comisión: ",
     "ycd":"Cancelado",
     "lswt":"Histórico",
     "qsrzyjg":"Por favor ingrese el precio de toma de ganancias",
     "qsrzsjg":"Por favor introduzca el precio del stop loss",
     "ccsl":"Número de posiciones: ",
     "ccjg":"Precio de posición: ",
     "ggbs":"Aprovecha múltiples: ",
     "zy2":"Saca provecho: ",
     "zs2":"Detener la pérdida de: ",
     "zje":"Suma global: ",
     "ss":"Lotes: ",
     "kcjg":"Precio de apertura: ",
     "bzjl":"Tasa de margen: ",
     "lscc":"Histórica",
     "gmj":"Precio de compra: ",
     "guadan":"Orden pendiente",
     "dqjg":"Precio actual: ",
     "gdjg":"Precio de pedido pendiente: ",
     "pcjg":"Precio de cierre: ",
     "ccsj":"Tiempo de mantenimiento de la posición: ",
     "gdsj":"Tiempo de espera del pedido: ",
     "pcsj":"Hora de cierre: ",
     "fdjyk":"Ganancias y pérdidas netas flotantes",
     "pcsl":"Cantidad de cierre",
     "qrpc":"Confirmar cierre de posición",
     "ypc":"Posición cerrada",
     "ss2":"Lotes",
     "qsrss":"Ingrese el tamaño del lote",
   },
   "gjrz":{
     "sfyz":"Certificación KYC",
     "t1":"1. Admite imágenes en formato JPG, JPEG o PNG de menos de 8 M.",
     "t2":"2. La foto del DNI debe ser clara y no se permite modificación ni bloqueo. El retrato, el número de identificación y el nombre deben estar claramente visibles.",
     "t3":"3. La foto debe tomarse sin sombrero y se recomienda no usar maquillaje. Los rasgos faciales de la persona que porta el documento deben ser claramente visibles y todo el brazo debe quedar expuesto.",
     "t4":"DE ACUERDO",
     "bh":"Rechazar",
     "shz":"Bajo revisión",
     "shtg":"Examen aprobado",
     "nyrzcg":"Has sido autenticado exitosamente",
     "sczjz":"Subir foto de identificación",
     "sczjzmz":"Sube una foto de frente de tu documento de identidad",
     "sczjbmz":"Sube la foto del reverso de tu DNI",
     "scgrqmz":"Sube una foto de tu DNI en mano",
     "gjlb":"Lista de países",
     "qxzgjlb":"Seleccione un país/región",
     "zsxm":"nombre real",
     "qsrzsxm":"Introduce tu nombre real",
     "zjlx":"Tipo de certificado: ",
     "zjhm":"número de identificación",
     "qsrzjhm":"Introduce tu número de DNI",
     "khh":"banco de apertura de cuenta",
     "qsrkhh":"Ingrese al banco de apertura de cuenta",
     "yhkh":"número de tarjeta bancaria",
     "qsryhkh":"Introduzca el número de tarjeta bancaria",
   },
   "status":{
     "statusText":['Error','En revisión','Éxito'],
   },
   "download":{
     "t1":"Comercio móvil, en cualquier momento y en cualquier lugar",
     "xz":"Descargar",
   },
   "langNew":{
     "cxsqsh": "Volver a solicitar el canje",
     "jxtg": "Continuar hospedando",
     "szhb": "Criptomoneda",
     "gjs": "Metal",
     "ny": "Energía",
     "yy": "Crudo",
     "jy": "Comercio",
     "jmhb": "Criptomoneda",
     "yxhy": "Contrato perpetuo",
     "gdjy": "orden pendiente",
     "khh": "Abrir cuenta bancaria",
     "qsrkhh": "Por favor ingrese al banco",
     "yhkh": "Cuenta bancaria",
     "qsryhkh": "Por favor, introduzca el número de cuenta bancaria",
     "mnzh":"cuenta demo",
     "zjjypt":"La mejor plataforma comercial",
     "brjmzndxq":"Este software satisface todas sus necesidades con la mejor experiencia técnica.",
     "jx":"Continuar",
     "yssm":"Declaracion de privacidad",
     "fxqzc":"Política contra el lavado de dinero",
     "jgxkz":"Licencia regulatoria",
     "ckgd":"Más",
     "gd":"Más",
     "dd":"Orden",
     "ckdd":"Ver pedidos",
     "yxdd":"Perpetuo",
     "qqdd":"Opciones",
     "hand":"Muchos= ",
     "lxwm":"Contáctenos",
     "tpfzl":"Coloque su imagen aquí, o ",
     "liulang":"navegar",
     "zctpgs":"Soporte: JPG, JPEG2000, PNG",
     "ysr":"Ingreso mensual",
     "ndysr":"Tus ingresos mensuales",
     "qsrndysr":"Introduce tus ingresos mensuales",
     "yqtzje":"Monto de inversión esperado",
     "qsrtzje":"Ingrese el monto de inversión esperado",
     "zszh":"Cuenta real",
     "qdl": "Por favor, registrese",
     "zx": "Favoritos",
     "hkdz":"Dirección de pago",
     "dkje":"Monto del préstamo: ",
     "zlx":"Interés total: ",
     "hkze":"Reembolso total: ",
     "qcz":"ir a depositar",
     "yebz":"Tu saldo es insuficiente, por favor recarga",
     "dhje":"Monto a reembolsar：",
     "hkjl":"orden de pago：",
     "hkje":"Balance：",
     "kyye":"Reembolso：",
     "qb": 'Todo',
     "lmc": "Nombre de la cadena：",
     "search": "Buscar",
     "mrjg":"Precio",
     "lxkf":"Contacto",
     "wyj":"daños y perjuicios",
     "yxsj":"Correr：",
     "jssj":"Finalizar：",
     "hksj":"Finalizar：",
     "sysj":"Tiempo restante：",
     "jkqx":"Plazo del préstamo：",
     "yq":"Atrasado：",
     "qqss":"Su orden de negociación de opciones ha expirado y su pérdida es",
     "qqlr":"Su orden de negociación de opciones ha caducado y su beneficio es",
     "bz":"Divisa",
     "dzje":"Cantidad recibida",
     "lxyxzc":"Soporte por correo electrónico",

     "mnzh": "Cuenta Demo",
         "zszh": "Cuenta real",
         "qsrgjc": "Por favor ingrese palabras clave",
         "wh": "Divisas",
         "szhb": "Moneda digital",
         "js": "Metal",
         "ny": "Energía",
         "sj": "precio de mercado",
         "gd": "Pedido pendiente",
         "mr": "Comprar",
         "mc": "Vender",
         "ss": "Tamaño del lote",
         "qsrss": "Por favor ingrese el tamaño del lote",
         "zy": "Obtener ganancias",
         "zs": "Stop Loss",
         "qsrzyj": "Por favor ingrese el precio de toma de ganancias",
         "qsrzsj": "Por favor ingrese el precio de stop loss",
         "xfbzj": "Margen requerido:",
         "kyye": "Saldo disponible:",
         "cc": "Posición",
         "ypc": "Posición cerrada",
         "name": "nombre",
         "ddh": "Número de pedido",
         "mmfx": "Dirección de compra y venta",
         "gmfs": "Método de compra",
         "xdj": "Precio del pedido",
         "sxf": "Tarifa de servicio",
         "sxf2": "Tarifa de tramitación:",
         "cz": "Operación",
         "pc": "Posición Cerrada",
         "cx": "Deshacer",
         "pccg": "Cierre exitoso",
         "dl": "Iniciar sesión",
         "yxhzhdl": "Correo electrónico e inicio de sesión en la cuenta",
         "qsryxhzh": "Ingrese su dirección de correo electrónico o cuenta",
         "mm": "Contraseña",
         "qsrmm": "Por favor ingrese una contraseña",
         "cjxnzh": "Crear una cuenta demo",
         "wjmm": "Has olvidado tu contraseña",
         "myzh": "Sin cuenta",
         "zc": "Registro",
         "wjmm2": "Olvidé mi contraseña",
         "zh": "Cuenta",
         "qsrzh": "Ingrese el número de cuenta",
         "yzm": "Código de verificación",
         "qsryzm": "Por favor ingrese el código de verificación",
         "hqyzm": "Obtener código de verificación",
         "qrmm": "Confirmar contraseña",
         "qzcsrmm": "Por favor ingrese la contraseña nuevamente",
         "qd": "OK",
         "yxh": "Número de buzón",
         "qsryxh": "Por favor ingrese su número de buzón",
         "sjh": "Número de teléfono móvil",
         "qsrsjh": "Por favor ingrese su número de teléfono",
         "xm": "Nombre",
         "qsrxm": "Por favor ingrese su nombre",
         "gj": "Nacionalidad",
         "qxzgj": "Por favor seleccione una nacionalidad",
         "zjlx": "Tipo de certificado",
         "qxzzjlx": "Seleccione un tipo de documento",
         "zjhm": "Número de documento",
         "qsrzjhm": "Ingrese el número de identificación",
         "qpsbsczj": "Tome una foto y cargue su ID",
         "pszm": "Disparar de frente",
         "psfm": "Dispara al reverso",
         "qsczmz": "Sube una foto frontal",
         "qscfmz": "Sube una foto invertida",
         "scqmz": "Sosteniendo una foto firmada",
         "qscqmz": "Sube una foto firmada",
         "wyyd": "He leído y entendido",
         "yhxy": "Acuerdo de usuario",
         "grzx": "Centro personal",
         "gnlb": "Lista de Funciones",
         "smrz": "Autenticación de nombre real",
         "rj": "Depósito",
         "cj": "Retiro",
         "zhjl": "Registros de cuentas",
         "xx": "Mensaje",
         "wdyq": "Mi invitación",
         "zhaq": "Seguridad de la cuenta",
         "sz": "Configuración",
         "lmc": "Nombre de la cadena",
         "bcewm": "Guardar código QR",
         "fzdz": "Copiar dirección",
         "fzcg": "Copia exitosa",
         "rjsl": "Cantidad del depósito",
         "qsrsl": "Por favor ingrese la cantidad",
         "zdsl": "Cantidad mínima",
         "pzms": "Valor hash",
         "qsrpzms": "Por favor ingrese el valor hash",
         "lkrj": "Depósito inmediatamente",
         "cjdz": "Dirección de retiro",
         "qsrcjdz": "Por favor ingrese la dirección de retiro",
         "cjsl": "Cantidad de retiro",
         "qsrcjsl": "Ingrese el monto del retiro",
         "lkcj": "Retirar inmediatamente",
         "ddh2": "Número de pedido:",
         "time": "tiempo:",
         "je": "Cantidad:",
         "zt": "Estado:",
         "bt": "Título:",
         "nr": "Contenido:",
         "sqz": "Aplicando",
         "yqhy": "invitar amigos",
         "yqhyyqzc": "Invita a amigos a registrarse juntos",
         "wdyqm": "Mi código de invitación",
         "wdyqlj": "Mi enlace de invitación",
         "fz": "Copiar",
         "xgdlmm": "Cambiar contraseña de inicio de sesión",
         "szjymm": "Establecer contraseña de transacción",
         "xgmm": "Cambiar contraseña",
         "tgyzmxgmm": "Cambiar contraseña mediante código de verificación",
         "jmm": "contraseña antigua",
         "qsrjmm": "Por favor ingrese la contraseña anterior",
         "dlmm": "Contraseña de inicio de sesión",
         "qsrdlmm": "Ingrese la contraseña de inicio de sesión",
         "jymm": "Contraseña de transacción",
         "qsrjymm": "Ingrese la contraseña de la transacción",
         "mmcd": "Contraseña de 6 dígitos",
         "tcdl": "Cerrar sesión",
         "zxkf": "Atención al cliente en línea",
         "bzzx": "Centro de ayuda",
         "ksrm": "Inicio rápido",
         "kcjg": "Precio de posición abierta",
         "pcjg": "Precio de cierre",
         "gdjg": "Precio de pedido pendiente",
         "pcfs": "Cerrar Posición",
         "hyl": "Monto del contrato",
         "thbzj": "Depósito de seguridad de reembolso",
         "gmsl": "Cantidad de compra",
         "sysl": "Cantidad restante",
         "sccg": "Guardado correctamente",
         "qxdl": "Inicia sesión primero",
         "sy": "ingresos",
         "tj": "Enviar",
         "sfz": "Tarjeta de identidad",
         "hz": "Pasaporte",
         "jz": "Licencia de conducir",
         "qt": "Otro",
         "qxzmnje": "Seleccione la cantidad simulada",
         "cjmnzhcg": "¡Crea una cuenta de demostración con éxito!",
         "dlmmts": "Ingrese la contraseña de inicio de sesión",
         "mmts": "Longitud de la contraseña de 6 a 24 dígitos",
         "jymmts": "Contraseña de 6 dígitos",
         "shz": "Revisando",
         "shtg": "Aprobado",
         "jj": "Rechazar",
         "xyb": "Siguiente",
         "emailgsts": "La dirección de correo electrónico ingresada no cumple con las reglas",
         "telgsts": "El formato del número de teléfono móvil ingresado es incorrecto",
         "lcmmbyz": "Las dos contraseñas ingresadas son inconsistentes",
         "gdj": "Precio de orden pendiente",
         "lx": "Tipo",
         "qsrgdj": "Ingrese el precio de la orden pendiente",
         "kccg": "¡Abrir posición con éxito!",
         "pcsl": "Cantidad de cierre",
         "mnts": "La cuenta virtual ha caducado, regenere",
         "wtfa": "Esquema de delegación",
         "kcsj": "Tiempo de posición abierta",
         "gbsj": "Hora de cierre",
         "gylx": "Intercambio",
         "hyjy": "Contrato",
         "zwsj": "Aún no hay datos",
         "zwkf": "Este canal de recarga aún no se ha abierto",
   },
   "langNew9":{
   "dzje": "Tendencias del mercado de productos comerciales",
   "lxyxzc": "Comienza tu viaje de trading digital",
   "text1": "Comienza creando una cuenta",
   "text2": "Invita a tus amigos a unirse a MFTG para jugar juntos",
   "text3": "Recarga tu cuenta",
   "text4": "Admite recargas de múltiples divisas, lo que te permite comenzar a operar rápidamente",
   "text5": "Comienza a operar",
   "text6": "Ofrece una variedad de pares comerciales de alta calidad para elegir y comercia felizmente en MFTG",
  "text7": "Invita a tus amigos para ganar USDT",
  "text8": "Invita a tus amigos para ganar USDT fácilmente",
  "text9": "La función de préstamo está en línea",
  "text10": "Cuando no tienes dinero, puedes solicitar un préstamo, que se emitirá el mismo día como muy pronto",
   "text11": "Opere con todos los activos",
   "text12": "Forex, criptomonedas, futuros, ETF, etc.",
   },
   "bank":{
     "text1":"Tu plataforma de gestión financiera más confiable",
     "text2":"Alertas de noticias en tiempo real",
     "text3":"Comprender información en tiempo real sobre la industria financiera.",
     "text4":"empezar a entender",
     "text5":"noticia de última hora",
     "text6":"Elige banco",
     "text7":"tarjeta bancaria",
     "text8":"Cantidad...",
     "text9":"Añadir tarjeta bancaria",
     "text10":"cuenta bancaria",
     "text11":"Por favor ingrese la cuenta bancaria",
     "text12":"Identificación de tarjeta",
     "text13":"Por favor ingrese el número de tarjeta ID",
     "text14":"código internacional bancario",
     "text15":"código internacional bancario",
     "text16":"Por favor ingrese el número de teléfono",
     "text17":"añadir",
     "text18": "Eliminar tarjeta bancaria",
     "text19": "Llegada real",
     "text20": "Información de retiro",
     "text21": "Seleccionar tarjeta bancaria",
     "text22": "Notas",
     "text23": "Monto mínimo de retiro:",
     "text24": "No se permite el retiro si el monto es menor que el monto mínimo de retiro",
     "text25": "Para garantizar la seguridad de los fondos, cuando cambie la política de seguridad de su cuenta o cambie su contraseña, revisaremos manualmente el retiro. Espere pacientemente a que el personal se comunique con usted por teléfono o correo electrónico",
     "text26": "Asegúrese de que su computadora y su navegador sean seguros para evitar que la información sea alterada o filtrada",
     "text27": "Para los USD que retire, cada operación significa que la cantidad total de activos que se muestran en la página de retiro que posee se reducirá por el monto de retiro correspondiente",
     "text28": "Registro de retiro",
     "text29":"Tipo de moneda fiduciaria",
   },
   "kxt": {
       "fs": "time",
       "fz":"min",
       "xs":"hour",
       "tian":"day",
       "zhou":"week",
     },
     "xbsg":{
       "title": "Startup",
       "wdsg": "Detalles",
       "scts": "Días de bloqueo:",
       "sy": "restante",
       "ljsg": "Suscríbete ahora",
       "ysk": "Agotado",
       "xzjdy": "Suscríbete ahora",
       "dy": "Suscripción",
       "fxjg": "Precio de emisión",
       "fxl": "Circulación",
       "ssrq": "Fecha de cotización",
       "yxqx": "Fecha de vencimiento",
       "qsrsl": "Por favor ingrese la cantidad",
       "syl": "cantidad restante",
       "sgrq": "Fecha de compra",
       "sgsl": "Cantidad de compra",
       "bz": "Moneda",
       "yebz": "Saldo USDT insuficiente",
       "tgsl": "cantidad de pases",
       "shz": "Revisando",
       "wtg": "Error",
       "ytg": "Aprobado",
       "ffsb": "Emisión fallida",
       "yth": "Reembolsado",
       "sbly": "Motivo de la falla",
       "jjly": "Motivo del rechazo",
       "bz2": "Moneda:",
       "fxjg2": "Precio de emisión:",
       "sgsl2": "Cantidad de compra:",
       "tgsl2": "Cantidad de pases:",
       "sssj": "Tiempo de comercialización",
       "sssj2": "Tiempo de comercialización:",
       "sgj": "Precio de suscripción",
       "sgj2": "Precio de compra:",
       "sgsj": "Tiempo de compra",
       "sgsj2": "Tiempo de compra:",
       "sbly2": "Motivo de la falla:",
       "jjly2": "Motivo del rechazo:",
       "bzj": "Margen:",
       "zsxf": "Tarifa de transacción total:",
       "djze": "Cantidad total congelada:",
       "djje": "Cantidad congelada"
       },
       "bzhl": {
         "title": "Dividendo",
         "gz": "Reglas",
         "tgdd": "Pedir deposito en garantía (custodia)",
         "zztgdzj": "Fondos en custodia",
         "yjjrsy": "Ingresos del día",
         "ljsy": "Ingresos totales",
         "tgzdd": "Pedido en custodia",
         "cljxcp": "Productos de la campaña estratégica",
         "dbxe": "Límite único",
         "rsyl": "Tasa de rendimiento diaria",
         "zq": "Ciclo",
         "qmr": "Comprar ahora",
         "bbzhzc": "Activos de la cuenta",
         "dd": "Pedidos",
         "buy": "Comprar",
         "jxcp": "Productos destacados",
         "ckdd": "Comprobar pedido",
         "gd": "Más",
         "xzbzts": "Sencillo y seguro. Los dividendos se pueden seleccionar en varias monedas",
         "qtbz": "Otras monedas",
         "zrsy": "Ganancias de ayer",
         "zdisyl": "Rendimiento mínimo",
         "zdasyl": "Rendimiento máximo",
         "day": "día",

         title1: 'Cuantificación de IA',
         ttzbt: 'Sigue ganando dinero todos los días',
         wdtg: 'Pedir deposito en garantía ',
         zztgdzj: 'Fondos en custodia',
         yjjrsy: 'Ingresos del día',
         ljsy: 'Ingresos acumulados',
         tgzdd: 'Pedido en custodia',
         tgdd: 'Pedido en custodia',
         t1: 'Gestión financiera estable y de bajo riesgo, reembolsable en cualquier momento si es necesario',
         t2: 'Su asistente de administración de dinero gratuito',
         cljxcp: 'Ciclo del producto',
         dbxe: 'Límite único',
         rsyl: 'Tasa de rendimiento diaria(%)',
         rsyl2: 'Tasa de rendimiento diaria：',
         zq: 'Ciclo',
         qmr: 'Comprar',
         ckgd: 'más',
         cpgk: 'Descripción del producto',
         pxsj: 'Tiempo de dividendo',
         tgzj: 'Capital en custodia',
         tqsh: 'Retorno anticipado',
         cpld: 'Destacados del producto',
         cpgz: 'regla',
         cont: 'La ganancia de USDT es administrada por el equipo profesional de la plataforma alojando USDT en la plataforma. Los participantes pueden obtener la participación en los ingresos de la plataforma durante el período de custodia del fondo, al que se puede acceder en cualquier momento, lo cual es seguro y conveniente.',
         zj: '100%fondos',
         aqbz: 'Seguridad',
         jjrsy: 'Ingresos de vacaciones',
         bjd: 'Ininterrumpido',
         cgcrh: 'Después de un depósito exitoso',
         dtqx: 'Calcule el interés del día',
         ljzr: 'Transfiera ahora',
         xqglgj: 'Herramientas gratuitas de administración de dinero',
         ddh: 'Número de pedido',
         tgje: 'Importe de la custodia',
         tgsj: 'tiempo de la custodia',
         yhl: 'Beneficios obtenidos/días restantes',
         xdsj: 'Tiempo de pedido',
         zt: 'estado',
         fh: 'espalda',
         qrnhsy: 'Ingreso anualizado de siete días',
         ygy: '1 mes',
         bn: 'Medio año',
         yn: '1 año',
         yuan: '$',
         tzfx: 'riesgo de inversión',
         shsc: 'Tiempo de redención',
         di: 'bajo',
         yggzr: 'Un día laborable',
         msgsxf: 'Cuota de suscripción gratuita',
         mr: 'Diario',
         dqfh: 'Retorno a vencimiento',
         ljgm: 'Comprar ahora',
         tgz: 'Pedido en custodia',
         sh: 'Retorno anticipado',
         ywc: 'terminado',
         ysh: 'Recuperar',
         all: 'Todos',
         "xzbzts": "Sencillo y seguro. Los dividendos se pueden seleccionar en varias monedas",
         "qtbz": "Otras monedas"
       },
       "bzhlgm": {
         "qtzq": "Ciclo de 7 días de USDT",
         "rsyl": "Tasa de devolución diaria",
         "lczq": "Ciclo financiero",
         "dbxe": "Límite único",
         "pxsj": "Calendario de pago de dividendos",
         "mr": "Diario",
         "dqfh": "Retorno a vencimiento",
         "tgzj": "Capital en custodia",
         "tqsh": "Retorno anticipado",
         "yjsy": "Ingresos anticipados (USDT)",
         "kyzc": "Activos disponibles (USDT)",
         "cpjs": "Acerca de nuestros productos",
         "tgje": "Importe de la custodia",
         "qsrtgje": "Por favor, introduzca el importe de la custodia",
         "qb": "Todos",
         "rm": "Comprar ahora",
         "cpzq": "Ciclo del producto",
         "gz": "Conozca las reglas y los intereses",
         "ktgje": "Cantidad depositable: ",
       },
       "bzhlwdtg": {
         "title": "Estado del pedido",
         "tgz": "En custodia",
         "ywc": "Completado",
         "ysh": "Recuperar",
         "tgje": "Importe de la custodia\/tiempo de la custodia",
         "rsyl": "Tasa de rendimiento diaria",
         "yhl": "Beneficios obtenidos\/días restantes",
         "xdsj": "Tiempo de pedido",
         "sh": "Redención",
         "ddxq": "Detalles del pedido",
         "ddh": "Número de pedido"
       },
       "bzjj": {
         "t1": "Ganar cada día",
         "cpld": "Destacados del producto",
         "scsq": "Depósito y retirada en cualquier momento",
         "pxzq": "Ciclo de dividendos",
         "mtxf": "Distribuir diariamente",
         "hqlx": "Interés actual",
         "zj": "Financiación al 100%",
         "aqbz": "Seguridad",
         "jjrsy": "Ingresos por vacaciones",
         "sybjd": "Ganancias continuas",
         "bjd": "Interrumpido",
         "cgcrh": "Tras un depósito exitoso",
         "dtqx": "Valor del interés en el mismo día",
         "jglz": "Por ejemplo",
         "syjs": "Cálculo de los ingresos",
         "cont2": "Mínimo: 10000U x 0,3%=30U",
         "cont3": "Máximo: 10000U x 0,5%=50U",
         "gywyj": "Acerca de los daños liquidados",
         "wycy": "Quiero participar"
       },
       "wydb": {
         "title": "Quiero un préstamo",
         "db": "Moneda",
         "dbz": "en moneda",
         "jl": "Grabar",
         "jdzq": "Período de préstamo (días)",
         "qhk": "Ir a pagar",
         "ljdb": "Moneda del préstamo acumulado (usdt)",
         "dhkbs" : "Número de pagos pendientes",
         "jkje": "Monto del préstamo (usdt)",
         "qsrje": "Por favor ingrese el monto",
         "rll": "Tarifa diaria",
         "hkfs": "Método de pago",
         "dqych": "Pagar el capital y los intereses una vez vencidos",
         "lx": "Interés",
         "fkjg": "Institución de préstamo",
         "tpsc": "Préstamo de crédito (carga de imagen)",
         "fwxx": "Información de la casa",
         "srzm": "Comprobante de ingresos",
         "yhmx": "Datos bancarios",
         "qscfwxx": "Cargue la información de la vivienda",
         "qscsrzm": "Cargue un comprobante de ingresos",
         "qscyhmx": "Cargue los datos bancarios",
         "qsczjz": "Cargue una foto de identificación",
         "zjz": "Foto de carnet",
         "yd": "He leído y acepto",
         "xy": "Acuerdo de préstamo de aplicación",
         "sqdb": "Haga clic para solicitar un préstamo",
         "gb": "cerrar",
         "qd": "OK",
         "ts": "Por favor revise el acuerdo de préstamo de la aplicación",
         "dbjl": "Registro de préstamo",
         "hkhth": "Número de contrato de préstamo",
         "wsh": "sin revisar",
         "yfk": "Desembolsado",
         "sqrq": "Fecha de solicitud",
         "zq": "punto",
         "dbsl": "Cantidad de Préstamos",
         "zhke": "Importe total del reembolso",
         "yhkxq": "Detalles de pago",
         "bqyhk": "Reembolso vencido en este período (USDT)",
         "hktips": "Asegúrese de que el saldo sea suficiente, si el saldo es insuficiente, recargue antes de pagar",
         "bj": "Director",
         "jie": "tomar prestado",
         "ljhk": "Pagar inmediatamente",
         "qcz": "Ir a recargar",
         "yebzqxcz": "Saldo insuficiente, recargue antes de pagar",
         "znj": "Cargo por pago atrasado",
         "yqts": "Número de días de mora",
         "kjdje": "Cantidad prestable",
         "rlxl": "Tasa de interés diaria",
         "rlxl2": "Tasa de interés diaria:",
         "yqll": "Tipo de interés diferido",
         "yqll2": "Tipo de interés diferido:",
         "ljlx": "Interés acumulado",
         "zrlx": "Interés de ayer",
         "jddd": "Orden de préstamo",
         "zxje": "Cantidad mínima:",
         "jexz": "Límite de cantidad:",
         "xypztp": "Imagen de la credencial:",
         "hkpztp": "Imagen del comprobante de pago:",
         "ysxsl": "Cantidad de interés ganado:",
         "ysxts": "Número de días que han devengado intereses:",
         "jdsl": "Monto del préstamo:",
         "fkjg2": "Institución de préstamo:",
         "zq2": "Período:",
         "sqrq2": "Fecha de solicitud:",
         "zhke2": "Importe total del reembolso:",
         "yff": "emitido",
         "hkz": "Reembolso",
         "yjq": "Borrado",
         "jjdk": "Rechazar préstamo",
         "ch": "Retirar",
         "cxsq": "Volver a aplicar",
         "cgkdkxz": "Límite de préstamo excedido",
         "hdgz": "Reglas del evento"
       },
       "xyf": {
         "título": "Puntuación de crédito",
         "dqxyf": "Puntaje crediticio actual",
         "hwqxyf": "No has obtenido puntos de crédito",
         "zwxyf": "Sin puntuación de crédito todavía",
         "pgsj": "Tiempo de evaluación",
         "xypz": "Credenciales (carga de imagen)",
         "cxtjsh": "Reenviar para revisión",
         "tjsh": "Enviar para revisión",
         "yjj": "Rechazado",
         "hq": "Obtener",
         "qx": "Cancelar",
         "qxwcsmrz": "Primero completa la autenticación con el nombre real"
       },
       "hkxq":{
         "dd": "Pedido",
         "fzhkdz": "Copiar dirección de pago",
         "hkxq": "Detalles de pago",
         "zlx": "Interés total",
         "zhk": "Reembolso total",
         "hkjg": "Agencia de pago",
         "qschkpz": "Cargue el comprobante de pago",
         "hkpz": "Vale de reembolso",
         "lxkfhk": "Comuníquese con el servicio al cliente para el pago"
       },
       "tipsNew":{
         "wjmmts": "Recuperar contraseña por código de verificación",
         "qscpztp": "Carga de la imagen del cupón",
         "emailgsts": "Por favor introduzca una dirección de correo electrónico válida",
         "telgsts": "El número de teléfono móvil es incorrecto.",
         "lcmmbyz": "Bitte bestätigen Sie Ihr Passwort",
         "zdsl": "Monto minimo ",
         "sldydy": "Cantidad mayor o igual a",
         "zxtzsl": "Cantidad mínima de inversión ",
         "ddz": "Esperando",
         "xs": "Hora",
         "min": "Monto minimo ",
         "max": "Cantidad máxima ",
         "yebz": "Saldo insuficiente",
         "qsrss": "Por favor ingrese el lote",
         "zdss": "Lotes mínimos",
         "yjj": "rechazado",
         "shz": "redención"
       },
       "status":{
         "statusText": ['falla','Esperando ser procesado','éxito'],
       },
       "jghy": {
         "jghy": "Suspensión",
         "yxhy": "Contrato perpetuo",
         "mz": "Alcista",
         "md": "Osuno",
         "gmj": "Precio de compra",
         "jsj": "Precio de liquidación",
         "xj": "Precio actual",
         "fx": "Dirección",
         "sl": "Importe",
         "jgsj": "Hora de entrega",
         "gb": "Cerrar",
         "jxxd": "Continuar con el pedido",
         "cclb": "Lista de pedidos",
         "zc": "Actualidad",
         "lscc": "Historia",
         "qblx": "Todos los tipos",
         "yk": "Beneficios y pérdidas",
         "ddqr": "Confirmación de pedido",
         "dqsj": "Hora de caducidad",
         "jssj": "Hora de entrega",
         "sy": "Beneficio",
         "tzje": "Monto de inversión",
         "zdje": "Precio más bajo 0",
         "kyye": "Saldo disponible",
         "sxf": "tarifa de manejo",
         "sxfl": "Tasa de tramitación",
         "jypz": "Par",
         "jyfx": "Dirección",
         "qrxd": "Confirmar",
         "dqye": "Saldo actual",
         "zt": "Estado"
       },
       "bbjy":{
        "cjsj":"Tiempo de transacción",
        "wtjg":"Precio de comisión",
        "cjjg":"Precio de transacción",
        "wcj":"Sin transacción",
        "ycj":"Transacción completada",
        "yqx":"Cancelado",
        "qxwt":"Cancelar delegación",
        "qsrxj":"Por favor introduce el precio límite"
      }
   // "langNew2":{
   //   "sy":"Pagina de inicio",
   //   "sc":"Mercado",
   //   "sclb":"Lista de mercado",
   //   "jy":"Comercio",
   //   "zh":"Cuenta",
   //   "db":"Préstamos",
   //   "zchm":"Número de registro",
   //   "cp":"Producto",
   //   "tzjd":"Préstamos de inversión",
   //   "zxzc":"Soporte en línea",
   //   "xd":"Orden",
   //   "zzjptgmnr":"Invierta en su futuro. Haga crecer su cartera en un sistema financiero justo y abierto.",
   //   "yy":"Aplicación",
   //   "pqnr":"Banca móvil que rompe con las reglas tradicionales y te proporciona herramientas precisas de gestión financiera.",
   //   "jiami":"Cripto",
   //   "tgnr":"Al realizar depósitos utilizando criptomonedas, obtienes una capa adicional de seguridad y garantizas un procesamiento rápido de las transacciones.",
   //   "jyl":"Volumen de operaciones las 24 horas",
   //   "ssjmhb":"Listado de criptomonedas",
   //   "zchy":"Usuarios Registrados",
   //   "djxz":"Haga clic para descargar",
   //   "azsc":"Mercado de Android",
   //   "pgsd":"Tienda Apple",
   //   "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
   // }
}



// WEBPACK FOOTER //
// ./src/lang/xby.js